/* eslint-disable no-unused-vars*/
/* eslint-disable react-hooks/exhaustive-deps*/

import { useSearchParams } from "react-router-dom";
import { ThemeContext } from "./theme-toggler/theme-context";
import { THEME_KEY } from "./theme-toggler/constant";
import { APPFACTOR_JSON_EDITOR_THEME, APPFACTOR_JSON_EDITOR_THEME_LIGHT, APPFACTOR_JSON_EDITOR_THEME_ICONS } from "../constant";
import { JsonEditor } from 'json-edit-react';
import CloudUploadIcon from '../asset/scan/CloudUploadIcon';

import { React, cloneElement, useState, useEffect, useContext, useMemo, useRef, useCallback } from "react"
import { getApplicationImage, checkUpdateNeeded, isValidIP, isValidFQDN, APPFACTOR, activateMenu, newSessionUID, appFactorColors } from "./commons"
import { MuiChipsInput } from "mui-chips-input";
import isCidr from "is-cidr";
import { List, ListItemText, ListItemButton, Button, DialogActions, Dialog, DialogTitle, DialogContent, DialogContentText } from "@mui/material";
import { menuTogleIcon, loadingIcon } from './APPF_ICONS'
import { UserContext } from "../context/user/UserContext";
import ScanResult from './ScanResult';
import AddCredential from './AddCredential';
import EnterSecretPassword from './EnterSecretPassword'
import { debounce } from "../utils/debounce"
import { DialogLogo } from "./APPF_ICONS";
import { APPF_radarIcon } from "./APPF_ICONS";
import { useEnsureHosts } from "../store/useCoreData";
import useCoreStore from "../store/coreStore";
import ScanIndexPage from "./ScanIndexPage.jsx";
import EditIndexPage from "./EditIndexPage.js";
import ScanSettingsPage from "./ScanSettingsPage.jsx";
import UploadAvroPage from "./UploadAvroPage.jsx";
import { wPostMessage, clearStoredSecret, holdVerifiedSecret, probedPassword } from "./EnterSecretPassword.js";
import HorizontalMenu from "./HorizontalMenu";
import PageHeader from "./page-header/PageHeader";
import { NavScan } from "../orion/assets/icons/navIcons";
import ScanProgressTiles from "./scan-progress/ScanProgressTiles";
import ScanProgressLog from "./scan-progress/ScanProgressLog";
import { RepoItem } from "./RepoItem.jsx";


import {
  Menu
} from '@mui/material';

import { plusIcon, closeIcon } from "./APPF_ICONS"

const HImput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

export function IFileUploadAvro(props) {
  return (
      <Button
          key={props.uploadID}
          id={props.uploadID}
          className="add-credential-file-upload"
          style={{
              backgroundColor: "transparent",
              border: "none",
              color: "var(--text-color-add-form)",
              boxShadow: "none",
              maxWidth: props.width?props.width:130,
              minWidth: props.width?props.width:139,
              ...(props.width?{
                  padding: 4,
                  paddingRight: 16    
              }:{
                  paddingLeft: 0,
                  paddingRight: 6    

              }),
              fontSize: 16

          }}
          component="label"
          role={undefined}
          variant="contained"
          endIcon={<CloudUploadIcon style={{ width: 28, height: 28 }} />}
      >
          {props.name ? props.name : ""}
          <div
              style={{
                  maxWidth: 1,
                  minWidth: 1
              }}
          >

              <HImput
                  type="file"
                  accept=".csv,.avro" 
                  multiple={true}
                  {...props.custom?
                      {
                          pattern:"avro"
                      }:
                      {}
                  }
                  
                  onChange={async (e) => {
                      try {

                        let csvFiles = [];
                        let avroFiles = [];


                        for(let i=0;i<e.target.files.length;i++){
                          const file = e.target.files.item(i);
                          try{
                          if(file?.name?.toLowerCase().endsWith(".avro")){ 
                              avroFiles.push(
                                {
                                  data:file,
                                  name:`${file.name}`,
                                  size:file.size
                                }
                              );
                            }else if(file?.name?.toLowerCase().endsWith(".csv")){
                              csvFiles.push(
                                {
                                  data:file,
                                  name:`${file.name}`,
                                  size:file.size
                                }
                              );
                            }
                          }catch(e){
                            console.log(e)
                          }
                        }

                        props.setUploadAvroData({
                          csvFiles:csvFiles,
                          avroFiles:avroFiles
                        })

                        props.setOpenUploadPage(true)

                      } catch (e) { /* */ }
                  }}
                  
              />
          </div>
      </Button>
  );
}


const bUnload = function (e) {
  (e || window.event).returnValue = "?";
  return 1;
}

/* the dashboard's own thousands separator, so a count reads the same on every
   band that carries one */
const fmtCount = (n) => Number(n || 0).toLocaleString();

/* How often a burst of progress messages is allowed to reach React. The
   orchestrator sends several per host - a /24 produces roughly a thousand in
   half a minute - and each one used to re-render the page, re-walk the whole
   progress tree for the stats and rebuild the log table's columns. Eight ticks
   a second still reads as live. */
const PROGRESS_TICK_MS = 120;

/* what the counters read before a scan has said anything */
const DEFAULT_SCAN_STATS = {
  total: 0,
  success: 0,
  failure: 0,
  percentage: 0,
};

export function inputBgColor(isDarkMode) {
  return isDarkMode ? "rgba(6, 6, 6, 1)" : "rgba(252,252,252,1)";
}

import {
  Box,
  MenuItem,
  Tooltip,
} from '@mui/material';

import { useAutocomplete } from "@mui/base/useAutocomplete"
import { styled } from "@mui/material/styles"
import { MainBg } from "./MainBg.jsx";
import { MainBg2 } from "./MainBg-2.js";
import { fontSize } from "@mui/system";

// Circle-minus counterpart of APPF_ICONS' closeIcon, shown while a scan is running.
const minimizeIcon =
  <svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 11H7v-2h10v2z" />
  </svg>


export const ShieldProxy = ({color = null, chatText = null, size = 24}) => {
  const linearId = "linearId_" + newSessionUID();

  return (
<>
  <svg 
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 42 42"
  colorInterpolationFilters="sRGB"
  
  width={size}
  height={size}
  >
    <defs>

      <linearGradient
        id={linearId}
        x1="479"
        y1="1322"
        x2="496"
        y2="-12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color?color:`rgba(127,26,7,0.642)`} />
        <stop stopColor={color?color:`rgba(127,26,7,1)`} offset={1} />
      </linearGradient>

    </defs>
    <path
      shapeRendering='crispEdges'
      transform="matrix(.042 0 0 .042-.42.0042)"
      d="m946.23 206.65c-.3-23-18-42-40.899-44.1-190.3-17.8-345.6-119.5-396.8-156.7-10.7-7.8-25.2-7.8-35.9 0-51.1 37.2-206.4 138.9-396.7 156.7-22.9 2.101-40.5 21.1-40.9 44.1-2.3 150.1 21.8 659.7 444.1 773.1 7.5 2 15.4 2 22.9 0 422.3-113.3 446.4-623 444.2-773.1"
      fill={`url(#${linearId})`}
    />
    <text x="13" y="28" fontSize="20" fill="white">{chatText?chatText:""}</text>
   
  </svg>
</>)
}

/**
 * Where the pointer is, for whatever opens under it.
 *
 * In the window's own coordinates. It used to be given screenX/screenY and
 * divided by the device pixel ratio, which is two things wrong at once: screen
 * coordinates carry the window's position on the desktop, and the ratio has no
 * business in a CSS length. On a 2x display that halved the number, so a menu
 * meant to open to the right of the pointer opened well to its left.
 */
const setMousePosition = (x, y) => {
  try {
    document.body.style.setProperty("--mouseX", `${x}px`);
    document.body.style.setProperty("--mouseY", `${y}px`);
  } catch (e) {/**/ }

}
const Root = styled("div")(
  ({ theme }) => `
    color:  "rgba(255,255,255,0.84)";
    font-size: 14px;
    label{
      color: "rgba(255,255,255,0.84)";
    }
`)

const isRange = (inValue) => {
  if (inValue.includes("-")) {
    let [start, end] = inValue.split("-");
    if (isValidIP(start) && isValidIP(end)) {
      return true
    }
  }

  return false;
}

const color2Percentage = "rgb(126,27,8)";
const color1Percentage = "rgb(73,99,187)";

const downloadFile =
{
  windows: "msi",
  linux: "appimage",
  mac: "dmg"
}

const CloseRoundedIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="1" d="M8.813 4.2L7 6.013L5.187 4.2L4.2 5.187L6.013 7L4.2 8.813L5.187 9.8L7 7.987L8.813 9.8L9.8 8.813L7.987 7L9.8 5.187L8.813 4.2ZM7 0C3.129 0 0 3.129 0 7C0 10.871 3.129 14 7 14C10.871 14 14 10.871 14 7C14 3.129 10.871 0 7 0ZM7 12.6C3.913 12.6 1.4 10.087 1.4 7C1.4 3.913 3.913 1.4 7 1.4C10.087 1.4 12.6 3.913 12.6 7C12.6 10.087 10.087 12.6 7 12.6Z" fill="#E8EAED"/>
    </svg>
  )
}

const kStyle = {
  background: "rgba(38,38,38,1)",
  border: "1px solid rgba(77,77,77,1)",
  textAlign: "center",
  display: "inline-block",
  color: "rgba(255,255,255,1)",
  padding: 8,
  lineHeight: "2px",
  paddingBottom: 0,
  borderRadius: 4,
  minWidth: 20,
  maxWidth: 20,
  minHeight: 26,
  maxHeight: 26,
}

const Label = styled("label")`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
  color:green
`

const InputWrapper = styled("div")(
  ({ theme }) => {

    let isDark = true; // theme.palette.mode === "dark";

    return (`
width:calc(100% - 31px);
border: 0.42px solid ${isDark === "dark" ? "rgba(255,255,255,0.2)" : "#d9d9d9"};
background: ${isDark === "dark" ? "linear-gradient(90deg, #9cc4f522, #b8f0f722)" : "#fff"};
border-radius: 4px;

padding: 1px;
padding-left:10px;
display: flex;
flex-wrap: wrap;
outline: 0;
&:hover {
   aborder-color: ${isDark === "dark" ? "rgba(255,255,255,0.9)" : "#40a9ff"};
}

&.focused {
    outline: 0;
  border-color: ${isDark === "dark" ? "rgba(255,255,255,0.9)" : "#40a9ff"};
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

& input {
    background-color:transparent;
  
  color: ${isDark === "dark" ? "rgba(255,255,255,0.65)" : "rgba(0,0,0,.85)"
      };
  height: 52px;
  box-sizing: border-box;
  padding: 4px 6px;
  width: 0;
  min-width: 30px;
  flex-grow: 1;
  border: 0;
  margin: 0;
  outline: 0;
}
`);
  }
)

function Tag(props) {
  const { label, onDelete, ...other } = props
  return (
    <div  {...other} className={other.className + " selCredTag"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        // document.querySelector("#scan-input").focus()
        // document.querySelector("#scan-input").click()
      }}
      style={{
        position: "relative",
      }}>
      <span>{label}</span>
      <div
        className={"closeStyledTag"}
        style={{
          float: "right",
          position: "absolute",
          background: "transparent",
          width: 24,
          height: 24,
          right: 3,
          top: 4,
          paddingTop: 0,
          textAlign: "center"
        }}
        onClick={onDelete}
      >
      <CloseRoundedIcon />
      </div>
    </div>
  )
}

// const tagColor = "rgba(129, 74, 141, 1)"
// const tagColor = "radial-gradient(64.41% 83.13% at 50.18% 50.09%, #CE5342 0%, #CE6142 49.5%, #CE4442 100%)"

// const tagColor = "lch(28% 56 42)"
const tagColor = "lch(40.1 73.1 36.09 / 80%)";

// background: radial-gradient(64.41% 83.13% at 50.18% 50.09%, #CE6142 0%, #CE5342 49.5%, #CE4442 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;



const StyledTag = styled(Tag)(
  ({ theme }) => `
display: flex;
font-size:12px;
align-items: center;
height: 30px;
margin-top: 1px;
margin-left:4px;
margin-bottom:4px;
color:white;
line-height: 22px;
max-width: 242px;

background: ${theme.palette.mode === "dark" ? tagColor : "#fafafa"};

border-radius: 4px;
box-sizing: content-box;
padding: 0 28px 0 12px;

outline: 0;
overflow: hidden;

// border:0.42px solid rgba(255,255,255,0.1);
&:focus {
  border-color: ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "#40a9ff"};
  background-color: ${theme.palette.mode === "dark" ? "transparent" : "#e6f7ff"};
}

& span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

& svg {
  font-size: 12px;
  cursor: pointer;
  padding: 4px;
}
`
)

/* how long the page waits for the orchestrator before saying it is not there,
   and when the page itself arrived - see the grace note in the component */
const OFFLINE_GRACE_MS = 2000;
const PAGE_LOADED_AT = Date.now();

/* What the orchestrator was doing when this page was last open.
   The socket answers a moment after the first paint, so `connected` is false
   for an instant on every load - and leaving that instant blank showed the
   card's gradient with nothing in it before the scan form arrived, which is
   the flicker on coming back to the page. Opening the way it closed removes
   it; the grace above still covers an orchestrator that has genuinely gone. */
const WAS_CONNECTED = (() => {
  try {
    return sessionStorage.getItem("scanOrchestratorWasConnected") === "1";
  } catch (e) {
    return false;
  }
})();

const baseUrl = "https://downloads.appfactor.cloud/orchestrator/latest/"

function filterValue(inData, inValue) {
  return inData.filter(a => a.message_type == inValue).filter((a, idx, s) => s.findIndex(t => t.host === a.host) === idx)
}





const NotConnectedOrchestrator = ({ gdata, setAnchorElScan, downloadRef, isDarkMode }) => {
  return (
    <>
      <div style={{
        marginTop: 140,
        textAlign: "center",
        minWidth: "800px",
        minHeight: "200px",

      }}>
        <div>
          {!gdata.connected ? <div style={{
            marginTop: 80,
            fontSize: 16,
            color: isDarkMode ? "#FFFFFFA6" : "#000000A6"
          }}><div>Orchestrator not connected. </div>Please <span
            onClick={() => {
              setAnchorElScan(downloadRef.current)
            }}
            style={{
              textDecoration: "underline",
              // color:"red",
              fontWeight: "bold"
            }}>download</span> above and run to start scanning.</div> : <></>}
        </div>
        <div
          style={{
            marginTop: 42,
            marginLeft: "calc( 50% - 80px)"
          }}
          className="cButton" onClick={() => {
            window.location.reload()
          }}>CONNECT</div>
      </div>
    </>
  )
}

function Scan() {
  const [orchestratorConfig, setOrchestratorConfig] = useState(null);

  const { theme } = useContext(ThemeContext);
  const isDarkMode = theme === THEME_KEY.DARK;
  const jsonEditorTheme = isDarkMode ? APPFACTOR_JSON_EDITOR_THEME : APPFACTOR_JSON_EDITOR_THEME_LIGHT;

  useEnsureHosts();
  const storeHosts = useCoreStore(s => s.hosts);
  const storeSystems = useCoreStore(s => s.systems);

  const [systemMap, setSystemMap] = useState({});
  const [hostsToRescan, setHostsToRescan] = useState([]);

  useEffect(() => {
    const localhost = [
      "0.0.0.0",
      "127.0.0.1",
      "::1",
      "fe80::1"
    ];

    let newMap = {}
    let rescan = []

    if (storeSystems.length > 0) {
      storeSystems.forEach(s => {
        let hn = s.hostName;
        let hid = s.id;
        let ct = s.cloudType;

        try {
          s.nics.forEach(n => {
            n.ips.forEach(ip => {
              if (!localhost.includes(ip.ip)) {
                rescan.push({
                  hostName: hn,
                  id: hid
                })
                newMap[ip.ip] = {
                  hostName: hn,
                  id: hid,
                  cloudType: ct
                }
              }
            })
          })
        } catch (e) {
          /* */
        }
      })
    }

    setSystemMap(newMap);
    setHostsToRescan(rescan.filter((a, idx, s) => s.findIndex(t => t.id === a.id) === idx))
  }, [storeHosts, storeSystems, setHostsToRescan, setSystemMap]);

  useEffect(() => {
    activateMenu("scan");
    if (localStorage.vCenterScanFill) {
      delete localStorage.vCenterScanFill;
    }
  }, []);

  const [doneProgress, setDoneProgress] = useState({});
  const [expanded, setExpanded] = useState("");
  const [tableRef, setTableRef] = useState(null);

  const [selectedList, setSelectedList] = useState([]);
  const [anchorElScan, setAnchorElScan] = useState(null);
  /** Opens a build from the downloads host; the cache-buster is the old one. */
  function openDownload(file) {
    setAnchorElScan(null);
    window.open(`${baseUrl}${file}?app=${Date.now()}`);
  }

  /* what the header's ⋮ opens: the controls that used to sit in the band */
  const [headerMenu, setHeaderMenu] = useState(null);

  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const settingsRef = useRef();

  // Start locked rather than trusting whatever sits in sessionStorage: it may be a
  // stale password, in which case the scan UI would come up with no prompt and
  // every secret operation would fail. EnterSecretPassword verifies the stored
  // value against the orchestrator and calls setLocalSecret once it is confirmed.
  const [localSecret, setLocalSecret] = useState("");
  const [localSecretError, setLocalSecretError] = useState("");

  const [firstTimePassword, setFirstTimePassword] = useState(false);


  const [open, setOpen] = useState(false);
  const [enableImport, setEnableImport] = useState(false)
  const [openScanAll, setOpenScanAll] = useState(false);
  const [awsScan, setAwsScan] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [ignoredHosts, setIgnoredHosts] = useState([]);
  const [scanStartTime, setScanStartTime] = useState(0);
  const [scanDurationTime, setScanDurationTime] = useState(0);

  const [searchParams] = useSearchParams();
  const [firstScan, setFirstScan] = useState(true);

  // Scan History is an imperative DOM-toggled dropdown (#scanHist), not React state,
  // so force-close it whenever the Progress Log becomes visible to avoid the two overlapping.
  useEffect(() => {
    if (!firstScan) {
      try {
        const sh = document.querySelector("#scanHist");
        if (sh) sh.style.display = "none";
      } catch (e) { /**/ }
    }
  }, [firstScan]);

  // Close the Scan History dropdown when clicking outside of it (or its toggle label).
  useEffect(() => {
    const handleClickOutside = (e) => {
      try {
        const sh = document.querySelector("#scanHist");
        if (!sh || sh.style.display === "none") return;
        if (sh.contains(e.target)) return;
        if (e.target.closest && e.target.closest('[data-scan-history-toggle]')) return;
        sh.style.display = "none";
      } catch (err) { /**/ }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [scanning, setScanning] = useState(false);
  // While a scan is running the progress panels can only be minimized (not closed) so the
  // user can always get back to them; a docked "Progress Log" tab restores the view.
  const [progressMinimized, setProgressMinimized] = useState(false);
  useEffect(() => {
    if (scanning) setProgressMinimized(false);
  }, [scanning]);

  /* The orchestrator's socket answers a moment after the page paints, so a
     reload showed "not connected", then swapped it for the scan view - a
     flicker on every load. The panel is held back for two seconds.

     Measured from when this module was first evaluated rather than from a
     mount: this page remounts while the socket settles, and a mount-scoped
     timer restarted with it, so the panel never appeared at all. */
  const [graceTick, setGraceTick] = useState(0);
  const offlineGraceOver = Date.now() - PAGE_LOADED_AT >= OFFLINE_GRACE_MS;
  useEffect(() => {
    if (offlineGraceOver) return undefined;
    const timer = setTimeout(
      () => setGraceTick((n) => n + 1),
      Math.max(0, OFFLINE_GRACE_MS - (Date.now() - PAGE_LOADED_AT)),
    );
    return () => clearTimeout(timer);
  }, [offlineGraceOver, graceTick]);

  const [scanningAws, setScanningAws] = useState(false);
  const [progressBarEnabled, setProgressBarEnabled] = useState(false);

  const [scanningAll, setScanningAll] = useState(false);
  const [warning, setWarning] = useState(``);
  const [lastRunScanData, setLastRunScanData] = useState({});

  const [scanbyHostName] = useState(true);
  const DEFAULT_SCAN_HISTORY = { success: [], fail: [], scanAutocomplete: [] };
  const [scanHistory, setScanHistory] = useState(localStorage.scanHistory ? JSON.parse(localStorage.scanHistory) || DEFAULT_SCAN_HISTORY : DEFAULT_SCAN_HISTORY);
  const [errorText, setErrorText] = useState("");

  const [protocolList, setProtocolList] = useState([]);
  const [dataSourcesList, setDataSourcesList] = useState([]);
  const [dataSourcesListForScan, setDataSourcesListForScan] = useState([]);

  const [secretsList, setSecretsList] = useState([]);
  const [secretsListType, setSecretsListType] = useState([]);

  const [searchvalue, setSearchvalue] = useState(JSON.parse(searchParams.get("ip")) || (localStorage.vCenterScanFill ? JSON.parse(localStorage.vCenterScan) : []));
  const [addedFromVcenter, setAddedFromVcenter] = useState(localStorage.vCenterScanFill ? true : false);
  const [activeTab, setActiveTab] = useState("newscan");

  const [logViewTree, setLogViewTree] = useState(false);
  const { gdata } = useContext(UserContext);

  /* remembered for the next load of this page */
  useEffect(() => {
    try {
      sessionStorage.setItem("scanOrchestratorWasConnected", gdata.connected ? "1" : "0");
    } catch (e) { /**/ }
  }, [gdata.connected]);

  /* What the page shows while it is still waiting to hear from the socket: the
     scan view if that is how it was left, so the card is never a bare gradient
     with nothing in it. After the grace, `connected` alone decides. */
  const showScanView = gdata.connected || (!offlineGraceOver && WAS_CONNECTED);

  /* The card is its artwork and what stands on it - one thing, drawn in one
     commit. The gradient used to be painted whatever else was ready, so coming
     into the page showed it alone while the orchestrator was still sending the
     protocols the form is built from: the flicker. Nothing of the card is drawn
     until there is a card to draw, and the grace above bounds the wait. */
  const scanCardReady = offlineGraceOver || (showScanView && protocolList.length > 0);

  // While the orchestrator is connected but the secret store has not been
  // unlocked, EnterSecretPassword puts a modal up. The scan UI used to render
  // underneath it regardless - and, because the modal only mounts once the
  // orchestrator reports back, it was briefly on screen in the clear before the
  // modal arrived. Keep it hidden until the store is open.
  const secretStoreLocked = gdata.connected && localSecret === "";

  // Lock again whenever the orchestrator goes away. Without this the unlocked
  // state outlived the connection it belonged to: stop the orchestrator, clear
  // the stored password, start it again, and the scan UI came back unprompted
  // because this component still held the secret in memory.
  useEffect(() => {
    if (gdata.connected) {
      return;
    }

    setLocalSecret("");
  }, [gdata.connected]);
  const [uploadID, setUploadID] = useState(newSessionUID());
  const [progressTree, setProgressTree] = useState(gdata.wsHistory ? gdata.wsHistory : {});
  const [itemsCountUptatedValue, setItemsCountUptatedValue] = useState(0);


  const refScroller = useRef();
  const downloadRef = useRef();

  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value: credValue,
    /* what has been typed into the credentials field: the menu's own search box
       shows it, so the list can be searched from where it is being read */
    inputValue: credSearch,
    focused,
    anchorEl,
    setAnchorEl,
    ...rest
  } = useAutocomplete({
    isOptionEqualToValue: (option, value) => option.label === value.label && option.type === value.type,

    // defaultValue: [{
    //   "label": "demo_linux",
    //   "type": "ssh",
    //   "selected": true
    // }],
    id: "scan-input",
    multiple: true,
    autoHighlight: true,
    options: protocolList.filter(f => f.type !== 'aws-ssm'),
    getOptionLabel: option => option.label,
  })

  const startScan = (dataSourceToScan = []) => {
    if (scanning || !gdata.connected) {
      return;
    }

    clearProgressHistory();
    setErrorText("")

    try {
      let hostList = [];
      let rangeList = [];
      let cidrList = [];
      let hostName = [];
      let dataSourcesList = [];


      if (searchvalue.length > 0) {
        let protocol = "";
        try {
          if (credValue.length > 0) {
            protocol = credValue.map(a => a.label);
          }
        } catch (e) {/**/ }

        if (protocol.length == 0 || typeof protocol === 'undefined') {
          setErrorText("Please select protocol")
          return;
        }

        ///

        function getHashicorpVaultToken() {
          try {
            let hashicorpVaultSettings = JSON.parse(localStorage.getItem("hashicorpVaultSettings"));

            if (typeof hashicorpVaultSettings?.namespace == "string" && hashicorpVaultSettings?.namespace.length > 0) {
              window._g.hashicorp_vault_namespace = hashicorpVaultSettings.namespace;
            }

            if (hashicorpVaultSettings?.type == "token") {
              window._g.hashicorp_vault_token = hashicorpVaultSettings.token;
              return;
            }

            if (hashicorpVaultSettings?.url) {
              const hashiVaultUrl = `${hashicorpVaultSettings?.url}/v1/auth/${hashicorpVaultSettings?.approle}/login`

              fetch(hashiVaultUrl, {
                method: "POST",
                body: JSON.stringify({
                  "role_id": hashicorpVaultSettings?.role_id,
                  "secret_id": hashicorpVaultSettings?.secret_id,
                }),
              })
                .then(response => {
                  if (response.status == 200) {
                    return response.json()
                  } else {
                    setHashicorpVaultToken(null)
                    return response.json()
                  }
                })
                .then(data => {
                  if (Object.keys(data).length > 0) {
                    let setToken = data?.auth?.client_token;
                    window._g.hashicorp_vault_token = setToken;
                  }
                })
                .catch(e => {
                  console.log(e, "HashiCorp settings are invalid. Please reconfigure.")
                  // setErrorText("HashiCorp settings are invalid. Please reconfigure.")
                })

            }
          } catch (e) {
            console.log(e, "HashiCorp settings are invalid. Please reconfigure.")
            // setErrorText("HashiCorp settings are invalid. Please reconfigure.")
          }


        }


        if (typeof window._g.hashicorp_vault_token == "undefined") {
          getHashicorpVaultToken();
        }



        searchvalue.forEach(aInputIn => {
          let aInput = aInputIn.trim();
          if (aInput != "") {
            try {
              if (isRange(aInput)) {
                rangeList.push(aInput);
              } else if (isCidr(aInput) > 0) {
                cidrList.push(aInput);
              } else if (isValidIP(aInput)) {
                hostList.push(aInput);
              } else {
                hostName.push(aInput);
              }
            } catch (e) {
              console.log(aInput, e)
            }
          }
        })

        let sessionUID = newSessionUID();
        window._g.sessionList.push(sessionUID);

        if (rangeList.length > 0) {
          rangeList.forEach(aRange => {
            let sessionUID = newSessionUID();
            window._g.sessionList.push(sessionUID);
            let [startIp, endIp] = aRange.split("-");
            let protocolIDS = JSON.stringify(protocol);

            window.postMessage(
              JSON.stringify(
                {
                  type: APPFACTOR.command,
                  sessionUID: sessionUID,
                  scan: true,
                  start_ip: startIp,
                  end_ip: endIp,
                  protocol: protocolIDS
                })
            );
          })

        }

        if (hostList.length > 0) {
          let hosts = JSON.stringify(hostList.filter((a, i, ar) => ar.indexOf(a) === i));
          window.postMessage(
            JSON.stringify(
              {
                type: APPFACTOR.command,
                sessionUID: sessionUID,
                scan: true,
                host: hosts,
                protocol: JSON.stringify(protocol)
              })
          );
        }

        if (cidrList.length > 0) {
          cidrList.filter((a, i, ar) => ar.indexOf(a) === i).forEach(el => {
            let sessionUIDC = newSessionUID();
            window._g.sessionList.push(sessionUIDC);

            window.postMessage(
              JSON.stringify(
                {
                  type: APPFACTOR.command,
                  sessionUID: sessionUIDC,
                  scan: true,
                  subnet: el,
                  protocol: JSON.stringify(protocol)
                })
            );
          })
        }

        if (scanbyHostName) {
          if (hostName.length > 0) {
            let sessionUID = newSessionUID();
            window._g.sessionList.push(sessionUID);

            let hosts = JSON.stringify(hostName.filter((a, i, ar) => ar.indexOf(a) === i));

            let protocol = "";
            try {
              if (credValue.length > 0) {
                protocol = credValue.map(a => a.label);
              }
            } catch (e) {/**/ }

            window.postMessage(
              JSON.stringify(
                {
                  type: APPFACTOR.command,
                  sessionUID: sessionUID,
                  scan: true,
                  host: hosts,
                  protocol: JSON.stringify(protocol)
                })
            )
          }
        }

        try {

          setScanHistory(p => {

            let currentAutocomplete = { search: searchvalue.sort(), protocols: credValue.sort() }

            try {

              p.scanAutocomplete.forEach(a => {
                if (
                  (a.search.length === currentAutocomplete.search.length && a.search.sort().every(function (value, index) { return value === currentAutocomplete.search[index] }))
                  &&
                  (a.protocols.length === currentAutocomplete.protocols.length &&
                    a.protocols.every(function (value, index) { return value.label === currentAutocomplete.protocols[index].label })
                  )
                ) {
                  throw new Error("already in history")
                }

                // if(a.search.sort() === currentAutocomplete.search.sort() && a.protocols === currentAutocomplete.protocols){

                // }
              })
            } catch (e) {
              // console.log(e)
              return p;
            }


            let newAutocomplete = [
              ...(p?.scanAutocomplete || []).concat(currentAutocomplete) || [],
            ]


            let newHistory = {
              success: [
                ...(p.success || []),
                // ...progressTree
                //   .filter(a => a.message_type == "success")
                //   .map(a => a.host)
                //   .filter((a, i, ar) => ar.indexOf(a) === i)
              ],
              fail: [
                ...(p.fail || []),
                // ...progressTree
                //   .filter(a => a.message_type == "failure")
                //   .map(a => a.host)
                //   .filter((a, i, ar) => ar.indexOf(a) === i)
              ],
              timeSuccess: { ...(p.timeSuccess || {}) },
              timeFail: { ...(p.timeFail || {}) },
              scanAutocomplete: newAutocomplete

            }

            localStorage.scanHistory = JSON.stringify(newHistory);

            return JSON.parse(JSON.stringify(newHistory))
          })


        } catch (e) {
          /* */
        }

        if (cidrList.length > 0 || hostList.length > 0 || hostName.length > 0 || rangeList.length > 0 )  {
          let resData = {}
          let scanProto = `${protocol}`
          resData[scanProto] = []
          cidrList.forEach(ip => {
            resData[scanProto].push(ip)
          })

          hostList.forEach(ip => {
            resData[scanProto].push(ip)
          })

          hostName.forEach(ip => {
            resData[scanProto].push(ip)
          })

          // console.log(resData)

          setLastRunScanData(
            resData
          )

          setScanning(true);
          if (firstScan) {
            setFirstScan(false);
          }
        }
      }

      if (dataSourceToScan.length > 0) {
          let sessionUID = newSessionUID();
          window._g.sessionList.push(sessionUID);  
          
          window.postMessage(
            JSON.stringify(
              {
                type: APPFACTOR.command,
                sessionUID: sessionUID,
                scan: true,
                targets: dataSourceToScan.map(dataS => ({
                      type: "data_source",
                      external_source_name: dataS.name
                    }) ),
              })
          )

          setScanning(true);
          if (firstScan) {
            setFirstScan(false);
          }
      }
      else if (cidrList.length == 0 && hostList.length == 0 && hostName.length == 0 && rangeList.length == 0) {
        setScanning(false);
        setErrorText("Add one or more valid scan target in the IP Address field")
      }
    } catch (e) {
      console.log(e)
      setScanning(false);
      setScanningAws(false);
    }
  }


  const scanAllHostsNew = useCallback(() => {
    if (scanning) {
      return;
    }

    clearProgressHistory();
    setErrorText("")
    setWarning("")

    setScanningAll(true)
    setScanning(true);

    try {

      let res = {}
      let missingProto = []
      let allAvailableProto = protocolList.map(a => a.label);

      for (let i = 0; i < storeHosts.length; i++) {
        let h = storeHosts[i];
        if (h.protocolId) {
          if (allAvailableProto.includes(h.protocolId)) {
            if (!ignoredHosts.includes(h.machineId)) {
              if (typeof res[h.protocolId] === 'undefined') {
                res[h.protocolId] = []
              }

              res[h.protocolId].push(h.scannedIp)
            }

          } else {
            missingProto.push(h.protocolId);
          }
        }
      }

      let targets = []
      setLastRunScanData(res);
      try {
        Object.keys(res).map((r) => {
          try {
            let proto = protocolList.filter(p => p.label == r);
            if (proto[0].type == "aws-ssm") {
              targets.push({
                instances: [],
                tags: [],
                type: "aws_ssm",
                protocol_id: r
              })
            } else {
              targets.push({
                "type": "host_list",
                "hosts": res[r],
                "protocol_ids": [r]
              })
            }
          } catch (e) {/* */ }
        })
      } catch (e) {
        /** */
      }
      setIgnoredHosts([])
      let sessionUID = newSessionUID();
      window._g.sessionList.push(sessionUID);

      window.postMessage(
        JSON.stringify(
          {
            type: APPFACTOR.command,
            scanRaw: true,
            payload: {
              "type": "scan",
              "id": sessionUID,
              "targets": targets
            },
          })
      );
      /* */
    } catch (e) {
      console.log(e)
      setScanning(false);
    }
  }, [scanning, protocolList, ignoredHosts]);

  const { refetchSystems } = useCoreStore.getState();


  useEffect(() => {
    checkUpdateNeeded("scan", refetchSystems)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function getHosts(inData, inValue) {
    let val = [];

    Object.keys(inData).forEach(host => {
      inData[host].forEach(item => {
        if (item.message_type == inValue) {
          val.push(item);
        }
      })
    })

    // inData.filter(a => a.message_type == inValue).filter((a, idx, s) => s.findIndex(t => t.host === a.host) === idx)

    return (
      <>
        <button onClick={() => {
          setSearchvalue(val.map(a => a.host))
        }}
          className={"wButton"}> Rescan </button>

        {val.map((k, i) => {
          return <div style={{
            padding: 3,
            margin: 4

          }} key={"fff" + i}>{k.host}</div>
        })}
      </>
    )
  }

  function processSecrets(eventData) {
    if (eventData.id === "10000000-0000-0000-0000-000000000000") {
      setTimeout(() => {
        eventData.secrets.forEach(s => {
          if (s.secret_key !== "__INIT__") {
            let del = {
              type: APPFACTOR.command,
              scanRaw: true,
              payload: {
                "type": "delete_secret",
                "id": `${newSessionUID()}`,
                "store_password": window._g.localSecret,
                "secret_key": `${s.secret_key}`
              }
            }
            console.log(del)
            window.postMessage(
              JSON.stringify(
                del
              )
            );
          }
        })
        console.log("[8] - Reloading ... ")
        // window.location.reload();
      }, 2000);

    }

    try {
      setSecretsList(eventData.secrets.filter(f => f.secret_key !== "__INIT__").map(s => s.secret_key));
    } catch (e) {
      /* */
    }

    try {
      let init = eventData.secrets.filter(f => f.secret_key == "__INIT__");
      if (init.length > 0) {
        window.postMessage(
          JSON.stringify(
            {
              type: APPFACTOR.command,
              scanRaw: true,
              payload: {
                "type": "delete_secret",
                "id": "cf121212-1212-1212-1212-000000000001",
                "store_password": window._g.localSecret,
                "secret_key": '__INIT__'
              }
            }
          )
        );

      }
    } catch (e) {
      /* */
    }

  }

  function convertMS(ms) {
    if (ms <= 0) {
      return ``
    }

    var d, h, m, s;
    s = Math.floor(ms / 1000);
    m = Math.floor(s / 60);
    s = s % 60;
    h = Math.floor(m / 60);
    m = m % 60;
    d = Math.floor(h / 24);
    h = h % 24;

    return `${d > 0 ? (d + "d ") : ""} ${h > 0 ? (h + "h ") : ""} ${s > 0 ? (m + "m ") : ""} ${s > 0 ? (s + "s") : ""}`
  }

  function processProtocols(eventData) {
    let newList = [];
    let first = true;
    eventData.protocols.sort().forEach(p => {
      newList.push({
        label: p.protocol_name,
        type: p.protocol_type,
        selected: first ? true : false
      });

      if (first) {
        first = false
      }
    })

    setProtocolList(newList);
  }

  /* Messages are counted here and handed to React on a timer, not one by one:
     the tree itself is mutated in place and returns the same object, so this
     counter is what the log, the stats and the table actually react to. */
  const progressTickPending = useRef(0);
  const progressTickTimer = useRef(0);

  const queueProgressTick = useCallback(() => {
    progressTickPending.current += 1;
    if (progressTickTimer.current) return;

    progressTickTimer.current = setTimeout(() => {
      progressTickTimer.current = 0;
      const batched = progressTickPending.current;
      progressTickPending.current = 0;
      setItemsCountUptatedValue(n => n + batched);

      /* the duration is read off the clock rather than off the message, so it
         belongs on this tick too */
      if (window._g.scanStartTime > 0) {
        setScanDurationTime(convertMS(new Date().getTime() - window._g.scanStartTime));
      }
    }, PROGRESS_TICK_MS);
  }, []);

  useEffect(() => () => {
    if (progressTickTimer.current) clearTimeout(progressTickTimer.current);
  }, []);

  /**
   * Everything the last scan left behind, so a new one starts on a clean log.
   *
   * Clearing the tree alone was not enough: the tiles colour themselves from
   * doneProgress, which is keyed by position and outlived the run that filled
   * it, so a new scan opened with the previous one's greens and reds. The
   * counters, the clock and the expanded row carried over the same way. Scan
   * History is deliberately untouched - that is the record of past runs.
   */
  const clearProgressHistory = useCallback(() => {
    /* a tick queued by the run that just ended would land on the new one */
    if (progressTickTimer.current) {
      clearTimeout(progressTickTimer.current);
      progressTickTimer.current = 0;
    }
    progressTickPending.current = 0;

    setProgressTree({});
    setItemsCountUptatedValue(0);
    setDoneProgress({});
    window._g.doneProgress = {};
    setStatsCounts(DEFAULT_SCAN_STATS);
    setScanDurationTime(0);
    setExpanded("");

    /* The last run's results go too - the hosts it reached and the ones it
       could not, with their times. They are kept in localStorage, so without
       this a new scan opened showing the previous one's successes and failures
       until it had produced its own. What survives is scanAutocomplete: that is
       the Scan History dropdown, the addresses and credentials to run again,
       and it is not a result. */
    setScanHistory(p => {
      const next = { ...p, success: [], fail: [], timeSuccess: {}, timeFail: {} };
      try { localStorage.scanHistory = JSON.stringify(next); } catch (e) { /**/ }
      return next;
    });
  }, []);

  const processIncomming = useCallback((event) => {

    try {
      let eventData = {
        ...(typeof event.data === 'string' ? JSON.parse(event.data) : (event.data || {})),
        eTimeStamp: event.timeStamp,
        timestamp: new Date().getTime()
      };

      try {
        if (eventData.scanner_config) {
          setOrchestratorConfig(eventData.scanner_config);
        }
      } catch (e) {
        /* */
      }

      try {
        if (eventData.type == "data_sources") {
          let dSources = Object.keys(eventData.data_sources).map(k => ({
              name: k,
              type: eventData.data_sources[k].data_source_type,
              url: eventData.data_sources[k].base_url,
              ...(eventData.data_sources[k].token_secret_ref ? {token_secret_ref: eventData.data_sources[k].token_secret_ref} : {}),
              ...(eventData.data_sources[k].credentials_secret_ref ? {credentials_secret_ref: eventData.data_sources[k].credentials_secret_ref} : {}),
              http_client_settings: eventData.data_sources[k].http_client_settings || null,
            }));

          setDataSourcesList(dSources || []);
        }

        if (eventData.type == "protocols") {
          processProtocols(eventData)
          window._g.protocolsMessage = eventData;
        }
        
        if (eventData.type == "secrets") {
          processSecrets(eventData)
        }

        // Any reply that fails to decrypt means the password we hold does not open
        // the store, whichever request it came back on. Only the get_secrets check
        // used to re-lock, so a failure from, say, saving a credential surfaced the
        // error while leaving the scan UI open and usable - a state where every
        // secret operation was going to fail.
        if (`${eventData.error}`.startsWith("Decryption failure")) {
          setLocalSecret("")
          setLocalSecretError(eventData.error)

          clearStoredSecret();
        }

        if (typeof eventData.type === 'undefined' && eventData.id.startsWith("420005ec")) {
          // An untyped reply is a failed one - the orchestrator only sends `type`
          // when a request succeeded. This used to treat *only* "Decryption
          // failure" as failure and let every other error fall through to an
          // else that unlocked: it wrote sessionStorage.ls and called
          // setLocalSecret. Against an orchestrator with no secret store
          // configured, the automatic check then unhid the scan UI with an
          // unverified password, with no user action at all. Only an explicit
          // success unlocks now; everything else stays locked.
          setLocalSecret("")

          if (eventData.error.startsWith("Decryption failure")) {
            setLocalSecretError(eventData.error)

            // Drop the rejected password as well. Leaving it in sessionStorage
            // meant the next page load read it back as an unlocked store, so the
            // prompt never appeared and every secret operation failed instead.
            clearStoredSecret();
          }
        } else if (eventData.type == 'secrets' && eventData.id.startsWith("420005ec")) {
          // The successful reply to the password check. It also has to clear the
          // failure state, otherwise a wrong attempt followed by the right one
          // unlocked the app while leaving "Decryption failure - possibly
          // incorrect password" on screen.
          //
          // The password is the one this reply answers for, not whatever is on
          // the global by now - see the note on probedPassword.
          const verified = probedPassword(eventData.id);

          if (verified) {
            holdVerifiedSecret(verified);

            try { sessionStorage.ls = btoa(verified); } catch (e) { /* */ }

            setLocalSecret(verified)
            setLocalSecretError("")
          }
        } else if (typeof eventData.type === 'undefined' && eventData.id.startsWith("42042042-f00d-face-babe")) {

          if (!eventData.error.startsWith("Decryption failure")) {
            setFirstTimePassword(true)
          }
        }

        if (eventData.type == "progress") {
          if (window._g.sessionList.includes(eventData.id)) {
            setProgressTree(p => {
              let newProgressTree = p;

              if (!newProgressTree[(eventData.host || eventData.data_source_id || eventData.protocol)]) {
                newProgressTree[(eventData.host || eventData.data_source_id || eventData.protocol)] = [];
              }

              newProgressTree[(eventData.host || eventData.data_source_id || eventData.protocol)].unshift(eventData);
              return newProgressTree
            })

            /* out of the updater, where it used to sit: an updater can run twice
               and the count would double */
            queueProgressTick();
          }
        }

        if (`${eventData.completed}` == "true" &&
          `${eventData.success}` == "true") {
          setScanning(false);
          setScanningAws(false);
          window.dispatchEvent(new CustomEvent('appfactor:data-invalidated'));
        }

        if (`${eventData.completed}` == "true" &&
          `${eventData.success}` == "false") {
          try {
            if (eventData.error && !eventData.id.startsWith("42042042") &&
              eventData.id != "cf121212-1212-1212-1212-000000000001" &&
              eventData.id != "cf121212-1212-1212-1212-000000000000" &&
              // The password check builds its id with a random suffix, so matching
              // one fixed id never excluded it: a failed attempt was copied into the
              // global banner, which nothing clears, and it stayed on screen after a
              // later attempt succeeded. The dialog reports this failure in context.
              !`${eventData.id}`.startsWith("420005ec")
            ) {
              setErrorText(eventData.error)
            }
          } catch (e) {
            console.log(e)
            /* */ }

          setScanning(false);
          setScanningAws(false);
        }

      } catch (e) {
        console.log(e)
      }

    } catch (e) {
      console.log(e)
    }

  }, [setProgressTree, queueProgressTick])

  const kd = useCallback((e) => {
    if (e.key == "Escape") {
      try {
        if (e.target.getAttribute("name") == "ipinput") {
          e.preventDefault();
          e.stopPropagation();
          setSearchvalue([]);
        } else if (e.target.id == "scan-input") {
          e.preventDefault();
          e.stopPropagation();
          rest.getClearProps().onClick()
        }
      } catch (e) { }
    }

    if (e.shiftKey && e.key == "F10") {
      let el = document.querySelector(`button[value="vcenterscan"] div div`);
      el.click();

      return;
    }


    if (e.ctrlKey) {
      try {
        let key = parseInt(e.key);

        if (key >= 1 && key < 10 || e.keyCode >= 49 && e.keyCode <= 57) {
          if (e.keyCode >= 49 && e.keyCode <= 57) {
            let keyPos = e.keyCode - 48;
            document.querySelector(`.sHis${keyPos}`).click()
          } else {
            document.querySelector(`.sHis${key}`).click()
          }

        }
      } catch (e) {
        console.log(e)
      }

      if (e.key == "Escape") {
        try {
          rest.dirty = true
          while (credValue.length > 0) {
            credValue.pop()
          }

          setSearchvalue([])
          document.activeElement.blur()
          document.activeElement.focus()
          let ae = document.activeElement;
          // console.log(document.activeElement )

          setTimeout(() => {
            document.querySelector("#scan-input").focus()
            document.querySelector("#scan-input").click()

            document.querySelector("#scan-input").focus()
            rest.dirty = true;
            credValue.splice(0, credValue.length);
            document.querySelector(".simpleAdd").focus()

            // document.querySelector("#scan-input").focus()
            // document.querySelector("#scan-input").click()



          }, 200);

          // document.querySelector("#input-wrapper input").focus();
          // document.querySelector("#input-wrapper input").click();

          // document.querySelector("#scan-input-label").click()
          // document.querySelector("#scan-input-label").nextElementSibling.focus()

        } catch (e) {
          /* */
          console.log(e)
        }
      }

      if (e.key == "Enter") {
        try {
          document.querySelector(".startScanButton").click()
        } catch (e) {
          /* */
        }

      }

    }
  }, [setSearchvalue, rest]);


  const [statsCounts, setStatsCounts] = useState(DEFAULT_SCAN_STATS);

  const getScannerConfig = () => {
    let orchestratorStatus = {
      "type": "get_scanner_config",
      "id": newSessionUID(),
    };

    wPostMessage(orchestratorStatus);
  }

  useEffect(() => {
    window.postMessage(
      JSON.stringify(
        {
          type: APPFACTOR.command,
          scanRaw: true,
          payload:
          {
            "type": "get_protocols",
            "id": newSessionUID(),
            "store_password": window._g.localSecret,
          }
        }
      )
    );

    if (gdata.connected) {
      // window.addEventListener("beforeunload", bUnload);
       getScannerConfig();
    }

    activateMenu("scan");

    if (typeof window._g.protocolsMessage !== 'undefined') {
      processProtocols(window._g.protocolsMessage);
    }

    window.postMessage(JSON.stringify(
      { type: APPFACTOR.command, connect: true }
    ));

    window.addEventListener("message", processIncomming, false);
    window._g.ext_processingTime = new Date().getTime()


    window.addEventListener("keydown", kd, false);
    return () => {
      window.removeEventListener("message", processIncomming, false);
      // window.removeEventListener("beforeunload", bUnload);
      window.removeEventListener("keydown", kd, false);
    }

  }, []);

  useEffect(() => {
    if (scanStartTime > 0 && scanning) {
      window._g.scanStartTime = scanStartTime
      setScanDurationTime(convertMS(new Date().getTime() - scanStartTime))
    }
  }, [scanning, scanStartTime, setScanDurationTime]);


  useEffect(() => {
    try {
      // refScroller.current.scrollTop = refScroller.current.scrollHeight;
    } catch (e) {/* */ }
    try {

      let timesSuccess = {

      }

      let timesFail = {

      }

      /* One pass where there were two: this walks every message of every host
         and runs on each progress tick, so a /24 was crossing the whole tree
         twice a tick for numbers one pass gives. */
      try {
        let timeNow = new Date().getTime()
        Object.keys(progressTree).forEach(host => {
          progressTree[host].forEach(item => {
            if (item.message_type == "failure") {
              timesFail[host] = timeNow;
            } else if (item.message_type == "success") {
              timesSuccess[host] = timeNow;
            }
          })
        })
      } catch (e) {
        /* */
      }

      setStatsCounts(p => {
        let newStatsCounts = {
          ...p,
          total: Object.keys(progressTree).length || 0,
          success: Object.keys(timesSuccess).length || 0,
          failure: Object.keys(timesFail).length || 0,
          percentage: 0
        }

        newStatsCounts.percentage = (Math.round(Math.floor((newStatsCounts.success + newStatsCounts.failure) * 100) / newStatsCounts.total) + 0) || 0

        /* most ticks land on the same four numbers - the messages in between are
           log lines - and handing back the object we were given lets React skip
           the render entirely */
        if (p.total === newStatsCounts.total &&
            p.success === newStatsCounts.success &&
            p.failure === newStatsCounts.failure &&
            p.percentage === newStatsCounts.percentage) {
          return p;
        }

        return newStatsCounts;
      }
      );

      if (scanning == false) {
        setScanHistory(p => {

          let newHistory = {
            success: [
              ...p.success,
              // ...progressTree
              //   .filter(a => a.message_type == "success")
              //   .map(a => {

              //     if( typeof a.host === 'undefined'){
              //       let allmessagesWithID = progressTree.filter(ff=>ff.id == a.id);

              //       for( let i=0;i<allmessagesWithID.length;i++){
              //         if( typeof allmessagesWithID[i].host !== 'undefined'){
              //           return allmessagesWithID[i].host
              //         }
              //       }
              //     }

              //     return a.host

              //   })
              //   .filter((a, i, ar) => ar.indexOf(a) === i)
            ],
            fail: [
              ...p.fail,
              // ...progressTree
              //   .filter(a => a.message_type == "failure")
              //   .map(a => {

              //     if( typeof a.host === 'undefined'){
              //       let allmessagesWithID = progressTree.filter(ff=>ff.id == a.id)
              //       for( let i=0;i<allmessagesWithID.length;i++){
              //         if( typeof allmessagesWithID[i].host !== 'undefined'){
              //           return allmessagesWithID[i].host
              //         }
              //       }
              //     }

              //     return a.host
              //   })
              //   .filter((a, i, ar) => ar.indexOf(a) === i)
            ],
            timeSuccess: { ...p.timeSuccess || {} },
            timeFail: { ...p.timeFail || {} },
            scanAutocomplete: [
              ...p?.scanAutocomplete || [],
            ]

          }

          try {
            Object.keys(timesFail).map(ip => {
              let proto = " - ";
              try {
                Object.keys(lastRunScanData).forEach(sd => {
                  if (lastRunScanData[sd].includes(ip)) {
                    proto = sd
                    throw new Error("")
                  }
                })
              } catch (e) {/* */ }

              newHistory.timeFail[ip] = {
                timestamp: timesFail[ip], protocol:
                  proto
              };
            })
          } catch (e) {/**/ }

          try {
            Object.keys(timesSuccess).map(ip => {
              let proto = " - ";
              try {
                Object.keys(lastRunScanData).forEach(sd => {
                  if (lastRunScanData[sd].includes(ip)) {
                    proto = sd
                    throw new Error("")
                  }
                })
              } catch (e) { /* */ }

              let pproto = proto;

              newHistory.timeSuccess[ip] = {
                timestamp: timesSuccess[ip],
                protocol: proto
              };
            })
          } catch (e) { console.log(e) }


          try {
            newHistory.success = newHistory.success.filter((a, i, ar) => ar.indexOf(a) === i)
          } catch (e) {/**/ }

          try {
            newHistory.fail = newHistory.fail.filter((a, i, ar) => ar.indexOf(a) === i)
          } catch (e) {/**/ }

          if (!scanning) {
            setScanningAll(false)
          }

          // localStorage.scanHistory = JSON.stringify(newHistory);

          return newHistory;
        })
      }
    } catch (e) {
      console.log(e)
    }

  }, [progressTree, itemsCountUptatedValue, refScroller, scanning, scanningAll, setScanningAll, setStatsCounts]);

  useEffect(() => {
    if (scanning) {
      setScanStartTime(new Date().getTime())
    } else {
      if (scanStartTime > 0) {
        setScanDurationTime(convertMS(new Date().getTime() - scanStartTime))
      }
    }

  }, [scanning, setScanStartTime]);


  const tabStyle = {
    fontSize: 16,
    boxShadow: "",
  }

  function scanAws() {
    setIgnoredHosts([])
    clearProgressHistory();
    let sessionUID = newSessionUID();
    window._g.sessionList.push(sessionUID);

    window.postMessage(
      JSON.stringify(
        {
          type: APPFACTOR.command,
          scanRaw: true,
          payload: {
            type: "scan",
            id: sessionUID,
            targets: [{
              instances: [],
              tags: [],
              type: "aws_ssm",
              protocol_id: protocolList.filter(p => p.type === "aws-ssm")[selectedIndex].label
            }]
          },
        })
    );

    setScanning(true);
    setScanningAws(true);
    setAwsScan(false);
    if (firstScan) {
      setFirstScan(false);
    }

  }

  let ssmCredentials = protocolList.filter(p => p.type == "aws-ssm")

  const typing = debounce(() => {
    setTyping(false)
  }, 1000);


  function setTyping(val) {
    document.querySelector("body").setAttribute("typing", `${val}`)
    if (val) {
      typing()
    }
  }

  const [viewOption, setViewOption] = useState("scan");
  const [activeScanType, setActiveScanType] = useState("");
  
  const [openAddIndexPage, setOpenAddIndexPage] = useState(false);
  const [openEditIndexPage, setOpenEditIndexPage] = useState(false);


  const [activeRepoName, setActiveRepoName] = useState("");
  const [openSettingsPage, setOpenSettingsPage] = useState(false);
  const [openUploadPage, setOpenUploadPage] = useState(false);
  const [uploadAvroData, setUploadAvroData] = useState({});

  useEffect(() => {
    let newSess = newSessionUID()
    setUploadID(newSess);
  }, [uploadAvroData]);

  function refreshDataSources() {
  window.postMessage(
    JSON.stringify(
      {
        type: APPFACTOR.command,
        scanRaw: true,
        payload:
        {
            "type": "get_data_sources",
            "id": newSessionUID(),
            // "data_source_type": "gitlab"
        }
      }
    )
  );
}

useEffect(() => {
  if(gdata.connected) {
    refreshDataSources();

    let orchestratorStatus = {
        "type": "get_scanner_config",
        "id": newSessionUID(),
    };

      wPostMessage(orchestratorStatus);

  }
}, [gdata.connected]);

const [showProgressChart, setShowProgressChart] = useState(true);

/* The tiles and the kitt bar live on canvas now, outside React's updates.
   Scan keeps this ref current; the chart reads it in its own frame loop, so a
   progress message no longer rebuilds ~1200 SVG nodes. */
/* What the band says under the title: the hosts still being scanned, and how
   much the orchestrator has said since the page loaded. A host counts as in
   progress until its newest message is a success or a failure - the same test
   the tiles colour themselves by. The message count is the rail's, published on
   a throttle (see SidebarNav), so a burst of progress does not redraw the band
   a hundred times a second. */
const scansInProgress = useMemo(() => {
  const keys = Object.keys(progressTree || {});
  return keys.filter((host) => {
    const type = progressTree[host]?.[0]?.message_type;
    return type !== "success" && type !== "failure";
  }).length;
}, [progressTree]);

const progressChartSource = useRef({
  tree: {}, keys: [], done: {}, doneCount: 0, total: 0,
  percentage: 0, showBar: false, version: 0, onPick: () => {},
});

const pickProgressHost = useCallback((host) => {
  setExpanded(host);
  /* the log reads this on its next frame: it opens that host and scrolls to it */
  progressChartSource.current.pendingScrollTo = host;
}, [setExpanded]);

/* No dependency list: this runs after every render, writes to a ref only, and
   so cannot cause one. */
useEffect(() => {
  const source = progressChartSource.current;
  const keys = Object.keys(progressTree);

  /* The per-host outcome the tiles colour themselves from. The progress table
     used to derive this on its way to rendering rows; the canvas log does not
     need it, so it is derived here, where the tree already is. */
  const done = {};
  keys.forEach((host, i) => {
    const type = progressTree[host]?.[0]?.message_type;
    if (type === "failure") done[i] = false;
    else if (type === "success") done[i] = true;
  });
  window._g.doneProgress = done;

  source.tree = progressTree;
  source.keys = keys;
  source.done = done;
  source.doneCount = Object.keys(done).length;
  source.total = statsCounts.total;
  source.percentage = statsCounts.percentage;
  source.showBar = !firstScan && statsCounts.total > 0;
  source.onPick = pickProgressHost;
  source.version++;

  /* the panel's own class only asks whether anything has finished yet, so the
     state behind it moves once rather than on every tick */
  setDoneProgress(prev =>
    (Object.keys(prev).length > 0) === (source.doneCount > 0) ? prev : done);
});
  
  // Panel-corner button to restore the minimized progress view; the scan keeps running
  // in the background while it's minimized. Rendered inside each view card (position:
  // relative) so it stays attached to the panel at any screen width.
  const minimizedProgressTab = !firstScan && progressMinimized &&
    <div
      className="progress-log-tab"
      title="Reopen Progress Log"
      onClick={() => setProgressMinimized(false)}
      style={{
        position: "absolute",
        // mirrors the Scan History toggle spot: 56px + the 17px content inset,
        // top-aligned with the "Scan computers" title block
        right: 73,
        top: 45,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "11px 18px",
        background: isDarkMode ? "rgba(17,14,15,1)" : "rgba(99,99,99,0.142)",
        color: isDarkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)",
        borderRadius: 8,
        cursor: "pointer",
        fontSize: 13,
        lineHeight: 1,
      }}>
      {scanning &&
        <div style={{ width: 14, height: 14, transform: "scale(0.8)", display: "flex", alignItems: "center", justifyContent: "center" }}>{loadingIcon}</div>}
      <span style={{ display: "inline-flex", alignItems: "center", lineHeight: 1 }}>Progress Log</span>
      {statsCounts.total > 0 &&
        <span style={{ opacity: 0.7, fontSize: 12, display: "inline-flex", alignItems: "center", lineHeight: 1 }}>
          {statsCounts.success + statsCounts.failure}/{statsCounts.total}
        </span>}
      <svg width="12" height="12" viewBox="0 0 24 24" style={{ opacity: 0.6, marginLeft: 2, display: "block" }}>
        <path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
      </svg>
    </div>

  return (
    <>
      <div className={"scanPage"} style={
        {
          /* A flat 1420px floor pushed the page past a 1440 window - the log
             panel's right half fell off the screen, clipped by the overflow
             below. The page keeps that width when there is room for it and
             gives way when there is not; the card column and the panel both
             shrink already. */
          minWidth: "min(1420px, 100%)",
          /* the left border counted on top of that 100% and pushed the page a
             pixel past the window */
          boxSizing: "border-box",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          height: window.innerHeight < 800 ? "auto" : "calc( 100vh - 10px)",
          width: "auto",
          borderRadius: 4,
          borderLeft: "1px solid rgba(255,255,255,0.081)",
          margin: 0,
          marginLeft: 0,
          padding: 0
        }
      }
      >
        {/* The credentials list, as the card the applications row menu uses:
            the same paper, the same head, the same rows with their mark in the
            gutter. It stays the autocomplete's own listbox - the props below
            carry the keyboard and the selection - only its clothes changed. */}
        {groupedOptions.length > 0 ? (
          <div
            className="actionMenuItems credential-menu orion-tokens"
            style={{
              /* flex, not block: the card is a column - a head that stays and a
                 list that scrolls under it - and an inline `block` here would
                 outrank the stylesheet and let the list run past the card */
              display: (groupedOptions.filter((option, index) => getOptionProps({ option, index })["aria-selected"] == false)).length == 0 ? "none" : "flex",
              /* Fixed, so the pointer's own coordinates place it: an absolutely
                 positioned menu answers to whichever ancestor happens to be
                 positioned, which is what the rail offset in the old --mouseX
                 was trying to correct for. It opens 14px to the right of the
                 pointer and only comes back when the window has no room for
                 its 300. */
              position: "fixed",
              zIndex: 9999,
              left: "min(calc(var(--mouseX, 600px) + 14px), calc(100vw - 316px))",
              top: "min(var(--mouseY, 500px), calc(100vh - 213px))",
            }}
          >
            <ul className={"noScroll"} {...getListboxProps()}>
              {/* The card's head is the search rather than a title: the name
                  of the list is already on the field this menu hangs off, and
                  what is wanted here is a way through fifteen of them.

                  It shows the credentials field's own text and sends the caret
                  back there on a click, rather than being a second input: the
                  list this menu draws is the autocomplete's, and it closes the
                  moment its input loses focus. So the typing lands in one
                  place and the filtering stays MUI's own. */}
              <div
                className="row-menu__head credential-menu__search"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  try { document.querySelector("#scan-input")?.focus(); } catch (err) { /**/ }
                }}
              >
                <span className="row-menu__badge">
                  <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                    <path
                      d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                <span className="row-menu__who">
                  <span className={`credential-menu__query${credSearch ? "" : " is-empty"}`}>
                    {credSearch || "Search credentials"}
                  </span>
                </span>
              </div>

              {groupedOptions
                .map((option, index) => {

                  if (credValue.map(cv => cv.label).includes(option.label)) {
                    return <li key={"go" + index} style={{ display: "none" }}></li>
                  }

                  return (
                    <li {...getOptionProps({ option, index })} key={"go" + index}>
                      <div className="row-menu__item">
                        <span className="row-menu__icon">
                          <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
                            <path
                              d="M12.65 10A5.99 5.99 0 0 0 7 6a6 6 0 1 0 5.65 8H17v4h4v-4h2v-4H12.65ZM7 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        <span className="credential-menu__label">{option.label}</span>
                      </div>

                      <span
                        className="credential-menu__delete"
                        title={`Delete "${option.label}"`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          var yes = confirm(`Are you sure you want to delete "${option.label}" credential?`);

                          // window.confirm() steals focus from the credentials input; MUI's
                          // Autocomplete treats that as blur and collapses the dropdown entirely.
                          // Refocus so it reopens instead of staying hidden (matters most when
                          // the user cancels, since there's no reload to mask it afterward).
                          try {
                            document.querySelector('#scan-input')?.focus();
                          } catch (e) { /**/ }

                          if (yes) {
                            window.postMessage(
                              JSON.stringify(
                                {
                                  type: APPFACTOR.command,
                                  scanRaw: true,
                                  payload: {
                                    "type": "delete_protocol",
                                    "id": newSessionUID(),
                                    "protocol_name": option.label
                                  },
                                })
                            );

                            setTimeout(() => {
                              window.location.reload();
                            }, 1000);

                            window.postMessage(
                              JSON.stringify(
                                {
                                  type: APPFACTOR.command,
                                  scanRaw: true,
                                  payload:
                                  {
                                    "type": "get_secrets",
                                    "id": "10000000-0000-0000-0000-000000000000",
                                    "store_password": window._g.localSecret,
                                  }
                                }
                              )
                            );
                          }
                        }}
                      >{closeIcon}</span>
                    </li>
                  )
                }
                )}
            </ul>
          </div>
        ) : null}

        {gdata.connected ?
          <EnterSecretPassword setLocalSecret={setLocalSecret} firstTimePassword={firstTimePassword} setFirstTimePassword={setFirstTimePassword} />
          : <></>}

        <Dialog
          open={awsScan}
          keepMounted
          slotProps={{
            paper: {
              sx: {
                color:isDarkMode ? "white" : "black",
                opacity: 1,
                paddingBottom: "20px",
                minWidth: 420,

                background: "var(--allAccentBackground)"
              }
            }
          }}
          onClose={() => {
            setAwsScan(false);
          }}
          aria-describedby="sdescription"
        >
          <DialogLogo />
          <DialogTitle>{"AWS-SSM Scan"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="sdescription" component="div" style={{
              marginLeft: 0,
              color:isDarkMode ? "white" : "black",
            }}>
              {ssmCredentials.length > 0 ?
                <>
                  <div>Select credential to start scan.</div>
                  <div style={{
                    position: "relative"
                  }}>
                    <Tooltip enterDelay={500} title={"Add new credential."} >
                      <div className="cButton below add"
                        style={{
                          position: "absolute",
                          right: -6,
                          padding: 0,
                          marginTop: -23,
                          // color:"red"
                        }}
                        onClick={() => {
                          try {
                            delete sessionStorage.lastProtocolType
                          } catch (e) {
                            /* */
                          }

                          if (gdata.connected) {
                            sessionStorage.lastProtocolType = "aws-ssm"

                            setOpen(true)
                          }

                        }}>
                        {plusIcon}
                      </div>
                    </Tooltip>
                  </div>
                </>

                : <><span>Please add AWS-SSM credentials</span></>}
            </DialogContentText>
            {ssmCredentials.length > 0 ?
              <Box className={"noScroll ssmCredList"} sx={{
                width: 'calc(100% - 0px)',
                fontSize: "12px",
                color:isDarkMode ? "white" : "black",
                background: "rgba(6, 6, 6, 0.25)",
                borderRadius: "4px",
                marginLeft: "0px",
                marginTop: "14px",
                maxHeight: "298px",
                minHeight: "298px",
                overflow: "scroll"
              }}>
                <List component="nav">
                  {
                    protocolList
                      .filter(p => p.type === "aws-ssm")
                      .map((s, i) => {
                        return (
                          <ListItemButton
                            className={"counterCreds"}
                            selected={selectedIndex === i}
                            onClick={(event) => setSelectedIndex(i)}
                            onDoubleClick={() => {
                              scanAws()
                            }}
                            key={"lib-" + i}
                            style={{
                              maxHeight: 32
                            }}
                          >
                            <ListItemText primary={s.label} />
                          </ListItemButton>
                        )
                      })
                  }
                </List>
              </Box>
              : <></>}
            {localSecretError != "" ? <div style={{
              color: "red",
              marginLeft: 10,
              background: "rgba(0,0,0,0.2)",
              padding: 10,
              borderRadius: 8
            }}>{localSecretError}</div> : ""}
          </DialogContent>
          <DialogActions style={{
            textAlign: "left",
            justifyContent: "left"
          }}>
            <Button className={"add-credential__save"}
              style={{
                marginBottom: 20,
                maxWidth: 172,
                minWidth: 172,
                marginLeft:15,
              }}
              onClick={(event) => {
                if (ssmCredentials.length > 0) {
                  scanAws()
                } else {

                  sessionStorage.lastProtocolType = "aws-ssm";

                  if (gdata.connected) {
                    setOpen(true)
                    if (event.shiftKey) {
                      setEnableImport(true)
                    }
                  }

                  // setAwsScan(false);
                }
              }}>{ssmCredentials.length == 0 ? "ADD Credential" : "OK"}</Button>

            <Button className={"add-credential__cancel"}
              style={{
                marginBottom: 20,
                maxWidth: 172,
                minWidth: 172,
                marginLeft: 9,
              }}
              onClick={() => {
                setAwsScan(false);
              }}>Cancel</Button>





          </DialogActions>
        </Dialog>

        <ScanIndexPage 
          refreshDataSources={refreshDataSources}
          isDarkMode={isDarkMode} 
          gdata={gdata} 
          dataSourcesList={dataSourcesList}
          setOpenAddIndexPage={setOpenAddIndexPage}
          openAddIndexPage={openAddIndexPage} 
        />
        

        <ScanSettingsPage 
          doneProgress={doneProgress}
          isDarkMode={isDarkMode} 
          gdata={gdata} 
          dataSourcesList={dataSourcesList}
          setOpenAddIndexPage={
            (a) => {
              setOpenSettingsPage(a);
              setTimeout(() => {
                getScannerConfig();
              }, 200);
            }
          }
          openAddIndexPage={openSettingsPage} 
        />
        
        <UploadAvroPage 
          isDarkMode={isDarkMode}
          uploadAvroData={uploadAvroData}
          setUploadAvroData={setUploadAvroData}
          openUploadPage={openUploadPage} 
          setOpenUploadPage={setOpenUploadPage}
        />



        <Dialog
        
          open={openScanAll}
          keepMounted
          slotProps={{
            paper: {
              sx: {
                color:isDarkMode ? "white" : "black",
                paddingBottom: "20px",
                backgroundColor: "#000000",
                background: "var(--allAccentBackground)"
              }
            }
          }}
          onClose={() => {
            setOpenScanAll(false);
          }}
          aria-describedby="sdescription"
        >
          <DialogLogo />
          <DialogTitle>{"Rescan all available host."}</DialogTitle>
          <DialogContent>
            <DialogContentText id="sdescription" style={{
              marginLeft: 0,
              fontSize: "12px",
              color:isDarkMode ? "white" : "black",
            }}>
              A scan job will be created containing all host previously scanned, the last used ip address and credentials will be automaticaly selected for the scan .
              Click on host to remove from scan.
            </DialogContentText>
            <Box className={"noScroll"} sx={{
              width: '100%', maxWidth: 420,
              background: "rgba(6, 6, 6, 0.25)",
              borderRadius: "8px",
              fontSize: "10px",
              marginLeft: "50px",
              marginTop: "20px",
              maxHeight: "420px",
              minHeight: "420px",
              overflow: "scroll"
            }}>

              <List component="nav">
                {
                  storeSystems && hostsToRescan ?
                    storeSystems.filter((a) => !ignoredHosts.includes(a.id)).map((s, i) => {
                      return (
                        <ListItemButton
                          key={"lib-" + i}
                          style={{

                            maxHeight: 32
                          }}
                          onClick={() => {
                            setIgnoredHosts(p => [...p, s.id])
                            setHostsToRescan(p => {
                              return p.filter((a) => a.id != s.id)
                            })
                          }}
                        >
                          <ListItemText primary={(i + 1) + " - " + s.hostName} />
                        </ListItemButton>
                      )
                    }) : <></>
                }
              </List>
            </Box>

          </DialogContent>
          <DialogActions style={{
            textAlign: "center",
            justifyContent: "center"
          }}>


            <Button className={"add-credential__save"}
              style={{
                marginLeft: 10,
                minWidth: 200,
              }}
              onClick={() => {
                setOpenScanAll(false);
                setFirstScan(false);
                scanAllHostsNew();
              }}>Scan</Button>

            <Button
              style={{
                minWidth: 210,
              }}
              className={"add-credential__cancel"} onClick={() => {

                setOpenScanAll(false);
                setIgnoredHosts([])
              }}>Cancel</Button>
          </DialogActions>
        </Dialog>


        <div className="discoveryTable" style={{
          backgroundColor: "transparent",
          padding: "10px",
          color: "white",
          borderRadius: 0,
          /* the page fills its frame: sized to its contents it stopped short of
             the window and left a band of the shell showing under it */
          height: "100%",
          minHeight: "420px",
          width: "100% - 40px"
        }}>
          <div
            style={{
              display: "flex",
              minWidth: 600,
              minHeight: "100%",

            }}
          >

            <div
              style={{
                /* takes whatever the log panel leaves: the old 0.811 grow with a
                   zero basis left a band of the row unclaimed, which is why the
                   column never used the width it had */
                flex: 1,
                minWidth: 0,
                maxWidth: "100%",
                position: 'relative',
                width: "100%",
              }}
            >
              {/* The orchestrator downloads, in the row menu the applications
                  table opens: the same card, the same head, the same rows with
                  their mark in the gutter. It replaced a drawn panel with its
                  own SVG chrome and three absolutely-placed rows. */}
              <Menu
                className="actionMenuItems"
                /* not #scanMenu: the sidebar's scan-steps panel owns that id,
                   and its stylesheet paints the paper transparent */
                id="scanDownloadMenu"
                anchorEl={anchorElScan}
                open={anchorElScan != null}
                onClose={() => setAnchorElScan(null)}
                slotProps={{ paper: { className: "orion-tokens" } }}
              >
                <div className="row-menu__head">
                  <span className="row-menu__badge">
                    <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                      <path
                        d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  <span className="row-menu__who">
                    <b className="row-menu__name">Download Orchestrator</b>
                  </span>
                </div>

                <MenuItem onClick={() => openDownload(downloadFile.windows)}>
                  <div className="row-menu__item">
                    <span className="row-menu__icon">
                      <svg role="img" viewBox="0 0 512 512" fill="none">
                        <path
                          fill="currentColor"
                          d="M98 145V250H225V127m15-2V250H408V101M98 368V263H225V386m15 1V263H408V411"
                        />
                      </svg>
                    </span>
                    Windows
                  </div>
                </MenuItem>

                <MenuItem onClick={() => openDownload(downloadFile.linux)}>
                  <div className="row-menu__item">
                    <span className="row-menu__icon">
                      <svg viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.93043 10.2396C5.93043 8.73635 6.5832 7.39811 7.59702 6.53656L6.04531 3.85156C4.74488 4.86129 3.76634 6.32273 3.30469 8.02391C4.02739 8.52678 4.50666 9.40545 4.50666 10.4041C4.50666 11.3673 4.06369 12.2165 3.3837 12.7277C3.88005 14.3391 4.84727 15.7186 6.10897 16.6759L7.55207 13.9012C6.56329 13.0399 5.93043 11.7195 5.93043 10.2396Z" fill="currentColor" />
                        <path d="M3.76527 10.4169C3.76527 11.5402 2.92142 12.4516 1.88258 12.4516C0.843232 12.4516 0 11.5403 0 10.4169C0 9.2941 0.843232 8.38281 1.88258 8.38281C2.92142 8.38281 3.76527 9.2941 3.76527 10.4169Z" fill="currentColor" />
                        <path d="M14.3417 15.3184C14.7795 15.3184 15.1917 15.4342 15.5539 15.6397C16.682 14.3544 17.411 12.6585 17.5315 10.7799L14.6077 10.7188C14.3826 13.0894 12.5301 14.9363 10.2784 14.9363C9.6552 14.9363 9.06043 14.7945 8.52371 14.5382L7.07031 17.2872C8.03922 17.8026 9.1269 18.0921 10.2784 18.0921C10.7753 18.0921 11.2627 18.0378 11.7323 17.9342C11.8324 16.4721 12.9622 15.3184 14.3417 15.3184Z" fill="currentColor" />
                        <path d="M16.2246 18.1675C16.2246 19.2906 15.3825 20.2015 14.3431 20.2015C13.3037 20.2015 12.4609 19.2906 12.4609 18.1675C12.4609 17.0435 13.3037 16.1328 14.3431 16.1328C15.3825 16.1328 16.2246 17.0435 16.2246 18.1675Z" fill="currentColor" />
                        <path d="M15.7423 5.07341C15.3163 5.39952 14.795 5.59253 14.232 5.59253C12.7861 5.59253 11.6153 4.3265 11.6153 2.76425C11.6153 2.68128 11.6188 2.60102 11.6245 2.52049C11.1849 2.42951 10.7306 2.38281 10.2666 2.38281C9.1044 2.38281 8.0053 2.67852 7.03125 3.20221L8.47611 5.95299C9.02254 5.68686 9.62861 5.53716 10.2666 5.53716C12.4983 5.53716 14.3378 7.35421 14.5891 9.69444L17.5129 9.59794C17.3838 7.87222 16.7373 6.30465 15.7423 5.07341Z" fill="currentColor" />
                        <path d="M16.1146 2.7694C16.1146 3.89306 15.2741 4.80407 14.2336 4.80407C13.1943 4.80407 12.3516 3.89306 12.3516 2.7694C12.3515 1.64566 13.1942 0.734375 14.2336 0.734375C15.2741 0.734375 16.1146 1.64566 16.1146 2.7694Z" fill="currentColor" />
                      </svg>
                    </span>
                    Linux
                  </div>
                </MenuItem>

                <MenuItem onClick={() => openDownload(downloadFile.mac)}>
                  <div className="row-menu__item">
                    <span className="row-menu__icon">
                      {/* framed on the mark itself: its artboard is 14x44, so
                          a square box would draw it as a sliver */}
                      <svg viewBox="-0.5 11.5 15 17" fill="none">
                        <path d="m13.0729 17.6825a3.61 3.61 0 0 0 -1.7248 3.0365 3.5132 3.5132 0 0 0 2.1379 3.2223 8.394 8.394 0 0 1 -1.0948 2.2618c-.6816.9812-1.3943 1.9623-2.4787 1.9623s-1.3633-.63-2.613-.63c-1.2187 0-1.6525.6507-2.644.6507s-1.6834-.9089-2.4787-2.0243a9.7842 9.7842 0 0 1 -1.6628-5.2776c0-3.0984 2.014-4.7405 3.9969-4.7405 1.0535 0 1.9314.6919 2.5924.6919.63 0 1.6112-.7333 2.8092-.7333a3.7579 3.7579 0 0 1 3.1604 1.5802zm-3.7284-2.8918a3.5615 3.5615 0 0 0 .8469-2.22 1.5353 1.5353 0 0 0 -.031-.32 3.5686 3.5686 0 0 0 -2.3445 1.2084 3.4629 3.4629 0 0 0 -.8779 2.1585 1.419 1.419 0 0 0 .031.2892 1.19 1.19 0 0 0 .2169.0207 3.0935 3.0935 0 0 0 2.1586-1.1368z" fill="currentColor" />
                      </svg>
                    </span>
                    Mac
                  </div>
                </MenuItem>
              </Menu>
              {/* The band every other page wears, on this page too: the
                  section's mark, the page's name, the page's own controls
                  where the rest of the product keeps its refresh, and the
                  Scan/Index strip through the middle.

                  The two wrappers are what the shared stylesheet paints the
                  band on - the hook it reads and the row it draws - the same
                  pair Discovery's 3D view hands it, since neither page has a
                  table toolbar to sit in. */}
              <div className="page-header-toolbar orion-tokens">
                <div>
                  <PageHeader
                    /* the rail's own Scan mark, greyed while the orchestrator
                       is away - the state the radar icon used to carry */
                    mark={cloneElement(NavScan, {
                      style: { filter: gdata.connected ? "none" : "grayscale(100%)" },
                    })}
                    title="Scan and index"
                    eyebrow={[
                      `${fmtCount(scansInProgress)} scans in progress`,
                      `${fmtCount(gdata.wsMessages)} messages`,
                    ]}
                    loading={scanning}
                    /* the rail's radar on the band's own mark while the
                       orchestrator is there, a plain ring while it is not */
                    className={gdata.connected ? "is-connected" : "is-offline"}
                    markTitle={gdata.connected ? "Orchestrator connected" : "Connect orchestrator"}
                    actions={
                      <>
                        <Tooltip title={"Download latest orchestrator"}>
                          <div
                            ref={downloadRef}
                            className="refreshButton"
                            onClick={() => {
                              setAnchorElScan(downloadRef.current);
                            }}
                          >
                            <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                              <path
                                d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                        </Tooltip>

                        {/* everything else the header used to carry, behind the
                            same row menu the applications table opens */}
                        <Tooltip title={"More"}>
                          <div
                            className="refreshButton"
                            onClick={(e) => setHeaderMenu(e.currentTarget)}
                          >
                            <svg width={18} height={18} viewBox="0 0 24 24" fill="currentColor">
                              <circle cx={12} cy={5} r={1.8} />
                              <circle cx={12} cy={12} r={1.8} />
                              <circle cx={12} cy={19} r={1.8} />
                            </svg>
                          </div>
                        </Tooltip>
                      </>
                    }
                    menu={
                      <HorizontalMenu
                        addLabel={false}
                        noScale
                        alignleft="true"
                        maxWidth={2 * 150}
                        value={viewOption}
                        setValue={setViewOption}
                        onChangeValue={(e, val) => {
                          if (val && val != viewOption) {
                            if (val == "index") {
                              setSearchvalue([]);
                              rest.getClearProps().onClick()
                            }
                            setViewOption(val);
                          }
                        }}
                        menuItems={["Scan", "Index"]}
                        menuValues={["scan", "index"]}
                      />
                    }
                  />
                </div>
              </div>

              {/* The band carries two controls; the rest live here, in the menu
                  the applications table opens on a row - same card, same head,
                  same items - with each entry keeping the mark and the words
                  its button had. */}
              <Menu
                className="actionMenuItems"
                anchorEl={headerMenu}
                open={headerMenu != null}
                onClose={() => setHeaderMenu(null)}
                slotProps={{ paper: { className: "orion-tokens" } }}
              >
                <div className="row-menu__head">
                  <span className="row-menu__badge">{NavScan}</span>
                  <span className="row-menu__who">
                    <b className="row-menu__name">Scan and index</b>
                  </span>
                </div>

                <MenuItem
                  onClick={() => {
                    setHeaderMenu(null);
                    setOpenSettingsPage(p => !p);
                  }}
                >
                  <div className="row-menu__item">
                    <span className="row-menu__icon">
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
                        <circle cx={12} cy={12} r={3.2} />
                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6h.09A1.65 1.65 0 0 0 10 3.09V3a2 2 0 0 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
                      </svg>
                    </span>
                    Orchestrator settings
                  </div>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    setHeaderMenu(null);
                    window.open(window.location.origin + `/ext/AppFactorVMWareScan.zip?t=${Date.now()}`);
                  }}
                >
                  <div className="row-menu__item">
                    <span className="row-menu__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" height={18} width={18} viewBox="0 0 63 63">
                        <linearGradient id="scan-menu-a" gradientUnits="userSpaceOnUse" x1="34.9087" x2="7.63224" y1="61.029" y2="13.7847">
                          <stop offset={0} stopColor="#1e8e3e" />
                          <stop offset={1} stopColor="#34a853" />
                        </linearGradient>
                        <linearGradient id="scan-menu-b" gradientUnits="userSpaceOnUse" x1="26.9043" x2="54.1808" y1="63.0788" y2="15.8345">
                          <stop offset={0} stopColor="#fcc934" />
                          <stop offset={1} stopColor="#fbbc04" />
                        </linearGradient>
                        <linearGradient id="scan-menu-c" gradientUnits="userSpaceOnUse" x1="4.22145" x2="58.7745" y1="19.6884" y2="19.6884">
                          <stop offset={0} stopColor="#d93025" />
                          <stop offset={1} stopColor="#ea4335" />
                        </linearGradient>
                        <path d="m31.499 47.2466c8.6985 0 15.75-7.0515 15.75-15.75s-7.0515-15.75-15.75-15.75-15.75 7.0515-15.75 15.75 7.0515 15.75 15.75 15.75z" fill="#fff" />
                        <path d="m17.8591 39.3751-13.63772-23.6212c-2.76527 4.788-4.22118922 10.2197-4.22137998 15.7489s1.45535998 10.961 4.22028998 15.7492c2.76494 4.7882 6.74181 8.7641 11.53071 11.5279 4.7889 2.7637 10.221 4.2179 15.7502 4.2164l13.6377-23.6212v-.0041c-1.3813 2.3954-3.369 4.3848-5.7632 5.7681s-5.1104 2.1118-7.8755 2.1122-5.4816-.7272-7.8762-2.1099c-2.3945-1.3826-4.3829-3.3714-5.7649-5.7663z" fill="url(#scan-menu-a)" />
                        <path d="m45.1379 39.3741-13.6376 23.6212c5.5292.0008 10.9611-1.4542 15.7496-4.2187 4.7885-2.7644 8.7648-6.7408 11.5291-11.5294 2.7642-4.7887 4.219-10.2207 4.2181-15.7499-.001-5.5292-1.4577-10.9606-4.2237-15.7483h-27.2754l-.0034.0021c2.7651-.0014 5.4818.7254 7.8769 2.1071 2.3951 1.3818 4.3841 3.3698 5.767 5.7643 1.3829 2.3944 2.1109 5.1108 2.1109 7.8758-.0001 2.7651-.7283 5.4814-2.1113 7.8758z" fill="url(#scan-menu-b)" />
                        <path d="m31.499 43.9688c6.8863 0 12.4688-5.5825 12.4688-12.4688s-5.5825-12.4688-12.4688-12.4688-12.4687 5.5825-12.4687 12.4688 5.5824 12.4688 12.4687 12.4688z" fill="#1a73e8" />
                        <path d="m31.4991 15.75h27.2754c-2.764-4.7888-6.74-8.76553-11.5283-11.53029-4.7883-2.76475-10.2202-4.22010235-15.7494-4.21970992s-10.9608 1.45650992-15.7487 4.22194992c-4.788 2.76543-8.76341 6.74275-11.52666 11.53185l13.63766 23.6212.0035.0019c-1.3837-2.394-2.1127-5.11-2.1136-7.8751s.7264-5.4817 2.1086-7.8765c1.3821-2.3948 3.3706-4.3835 5.7652-5.7659 2.3947-1.3825 5.1112-2.11 7.8763-2.1094z" fill="url(#scan-menu-c)" />
                      </svg>
                    </span>
                    VMWare scanner extension
                  </div>
                </MenuItem>

                {/* the upload keeps its own control - the file input lives in it */}
                <MenuItem className="scan-menu__upload" disableRipple>
                  <div className="row-menu__item">
                    <IFileUploadAvro
                      name="Upload AVRO or CSV"
                      uploadID={uploadID}
                      setUploadAvroData={setUploadAvroData}
                      setOpenUploadPage={setOpenUploadPage}
                    />
                  </div>
                </MenuItem>

                {orchestratorConfig?.http_client?.http_proxy &&
                  <MenuItem
                    onClick={() => setHeaderMenu(null)}
                    title={orchestratorConfig?.http_client?.http_proxy}
                  >
                    <div className="row-menu__item">
                      <span className="row-menu__icon">
                        <ShieldProxy size={18} color="rgba(32,76,32,1)" chatText="G" />
                      </span>
                      Using global proxy
                    </div>
                  </MenuItem>
                }
              </Menu>
              
              {viewOption == "scan" &&
                <div style={{
                  // filter: "url(#vignette-filter)",
                  position: "relative",
                  marginTop: 170,
                  /* Centred by its own margins rather than by a formula off the
                     container's width: while a scan runs this column narrows to
                     make room for the progress log, and that formula went
                     negative - which slid the card under the rail and cut the
                     IP field off. It gives way instead. */
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "100%",
                  maxWidth: 1103,//1086
                  minWidth: 0,
                  minHeight: 620,//611
                  maxHeight: 620,
                  paddingTop: "1px",
                  paddingLeft: "1px",
                  overflowY: "visible",
                }}>
                  {/* The scan's own progress used to be laid over this card, which
                      covered the form it belongs to. It is drawn at the top of
                      the progress log instead - see the panel at the end of this
                      file - so the card stays put and stays readable. */}
                  {minimizedProgressTab}

                  {scanCardReady &&
                  <div style={{
                    color: isDarkMode ? "#FFFFFF" : "#000000",
                    zIndex: 2,
                    position: "relative",
                    marginTop: 50,
                    marginLeft: 70,
                    // border: "1px solid rgba(255,255,255,0.23)",
                    width: "calc(100% - 140px)",
                    height: "calc(100% - 0px)",
                    visibility: secretStoreLocked ? "hidden" : "visible",
                  }}>
                    <div style={{ fontSize: 16, width: "100%", height: "100%" }}>Scan computers</div>
                    {gdata.connected &&
                      <div style={{ fontSize: 12, marginTop: 4, width: "100%", height: "100%", opacity: 0.5 }}>Input IP address/CIDR or hostname to start scanning</div>
                    }
                  </div>}
                  <div
                    style={{
                      position: "relative",
                      borderRadius: 8,
                      zIndex: 1111,
                      visibility: secretStoreLocked ? "hidden" : "visible",
                      minHeight: 360,
                      maxHeight: 360,
                      opacity: 1,
                      marginLeft: 17,
                      marginRight: 17,
                    }}>

                    <div style={{
                      borderRadius: 8,
                      margin: 0,
                      padding: 0,
                      paddingTop: 44,
                      width: "100%",
                      height: "100%",
                      opacity: 1,
                      zIndex: 1112,
                      backgroundColor: "transparent",
                    }}>
                      {/* begin scan page */}
                      {showScanView ?
                        // Only the complete absence of credentials is an empty
                        // state. Counting non-SSM credentials meant an SSM-only
                        // setup fell through to "add a credential" and never
                        // reached the scan form - which is where the AWS-SSM
                        // button lives, so an SSM scan was unreachable however
                        // many SSM credentials had been added.
                        protocolList.length == 0 ?
                          <>
                            <div style={{
                              textAlign: "center",
                              minWidth: "600px",
                              minHeight: "200px",
                            }}>
                              <div>
                                <div style={{
                                  marginTop: 80,
                                  fontSize: 14,
                                  color: "#FFFFFFA6"
                                }}>
                                  <div>In order to start scanning</div> add a credential
                                </div>
                              </div>
                              <div
                                style={{
                                  marginTop: 42,
                                  // .cButton is position:absolute, so it was centred by
                                  // hand with calc(50% - 130px) - half of a 260px button
                                  // that actually renders at 162px, leaving it off centre.
                                  // Centre it by translation instead, which does not care
                                  // how wide the button is.
                                  left: "50%",
                                  transform: "translateX(-50%)"
                                }}
                                className="cButton" onClick={() => {
                                  try {
                                    delete sessionStorage.lastProtocolType
                                  } catch (e) {
                                    /* */
                                  }
                                  if (gdata.connected) {
                                    setOpen(true)
                                  }
                                }}>Add credential</div>
                            </div>
                          </> :
                          <>


                            <div
                              className={`mainContainer-scan ${!firstScan && !progressMinimized ? "scanning" : ""}`}
                            >


                              <Root
                                onClick={() => {
                                  document.querySelector("#input-wrapper input").focus()
                                }}
                              >
                                <div className={"closeStyledTagTxt"}
                                  title={`Clear IP address / CIDR / Hostname.
Press ESCAPE while focused to clear.`}
                                  style={{
                                    top: "6px",
                                    color: isDarkMode ? "white" : "black",
                                    opacity:searchvalue?.length > 0 ? 0.7 : 0,
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setSearchvalue([]);
                                  }}
                                >CLEAR</div>
                                <div
                                  id={"input-wrapper"}
                                  style={{
                                    marginTop: -20,
                                    maxWidth: "calc(100% - 118px)",
                                    marginLeft: 55,
                                    padding: 0,
                                    paddingBottom: 0,
                                    borderRadius: 8,
                                    background: inputBgColor(isDarkMode),
                                  }}>
                                  <div
                                    style={{
                                      background: inputBgColor(isDarkMode),
                                      position: "absolute",
                                      width: "calc(100% - 158px)",
                                      marginTop: 0,
                                      marginLeft: 0,
                                      borderRadius: "8px 0 0 0",
                                      padding: 10,
                                      paddingLeft: 19,
                                      paddingTop: 17,
                                      zIndex: 1111,
                                      fontSize: 15,
                                      color: isDarkMode ? "rgba(255,255,255,0.84)" : "rgba(0,0,0,0.84)",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    {`IP Address / CIDR / Hostname ${searchvalue.length > 0 ? `( ${searchvalue.length} entr${searchvalue.length == 1 ? "y" : "ies"} ) ${addedFromVcenter ? ` - vCenter scan '${localStorage.vCenterAddress}'` : ""}` : ""}`}

                                  </div>
                                  <MuiChipsInput
                                    outline="none"
                                    tabIndex={1}
                                    className={"noScroll scanInput"}
                                    style={{
                                      color: isDarkMode ? "rgba(255,255,255,1)" : "rgba(0,0,0,0.94) !important",
                                      background: inputBgColor(isDarkMode),
                                      width: "calc(100% - 3px)",
                                      marginRight: 10,
                                      borderRadius: 8,
                                      maxWidth: "calc(100%)",
                                      marginLeft: 0,
                                      textAlign: "center",
                                      outline: "none !important",
                                      height: "86px",
                                      maxHeight: "86px",
                                      zIndex: 11,
                                      marginTop: 0,
                                      padding: 10,
                                      paddingLeft: 0,
                                      paddingTop: 42,
                                      overflow: "scroll",

                                      overflowX: "hidden",
                                      scrollbarColor: "var(--scan-main-input-chip-bg-color) transparent",
                                      scrollbarWidth: "thin",
                                    }}
                                    enterKeyHint={"on"}
                                    autoComplete={'one-time-code'}
                                    autoFocus={true}
                                    addOnBlur
                                    maxRows={1}
                                    data={[]}
                                    clearInputOnBlur
                                    name={"ipinput"}
                                    placeholder={searchvalue?.length == 0 ? "         ... 10.0.42.1    10.0.42.0/24  server42.dev.local" : ""}
                                    value={searchvalue}
                                    onKeyUp={e => {
                                      setTyping(true)
                                    }}
                                    onChange={(newValueIn) => {
                                      if (window.extendedLog) { console.log(`IN VALUE: ["${newValueIn}"]`, newValueIn); }
                                      let newValue = newValueIn.map(v => {
                                        if (window.extendedLog) { console.log(`NEW VALUE: ["${v.replaceAll(`"`, "").replaceAll(`'`, "").replaceAll("`", "")}"]`); }
                                        return v.replaceAll(`"`, "").replaceAll(`'`, "").replaceAll("`", "");
                                      })


                                      let parsedNewValues = [];
                                      try {
                                        newValue.forEach(inValue => {
                                          let value = inValue.trim();
                                          if (value.length > 0) {
                                            if (value.indexOf(",") > 0) {
                                              value.split(",").forEach(v => {
                                                if (v.length > 0) {
                                                  parsedNewValues.push(v);
                                                }
                                              });
                                            } else {
                                              parsedNewValues.push(value);
                                            }
                                          }
                                        });


                                        let spacesParsedNewValues = [];
                                        parsedNewValues.forEach(inValue => {
                                          let value = inValue.trim();
                                          if (value.length > 0) {
                                            if (value.indexOf(" ") > 0) {
                                              value.split(" ").forEach(v => {
                                                if (v.length > 0) {
                                                  spacesParsedNewValues.push(v);
                                                }
                                              });
                                            } else {
                                              spacesParsedNewValues.push(value);
                                            }
                                          }
                                        });
                                        if (spacesParsedNewValues.length > parsedNewValues.length) {
                                          parsedNewValues = spacesParsedNewValues;
                                        }
                                      } catch (e) {
                                        /* */
                                      }

                                      let parsedAgainForSeperators = [];

                                      parsedNewValues.map(ff => {
                                        if (ff.indexOf(",") > 0) {
                                          ff.split(",").forEach(v => {
                                            if (v.length > 0) {
                                              parsedAgainForSeperators.push(v);
                                            }
                                          });
                                        } if (ff.indexOf(" ") > 0) {
                                          ff.split(" ").forEach(v => {
                                            if (v.length > 0) {
                                              parsedAgainForSeperators.push(v);
                                            }
                                          });
                                        }
                                        else {
                                          parsedAgainForSeperators.push(ff);
                                        }

                                      });

                                      parsedNewValues = parsedAgainForSeperators

                                      try {
                                        parsedNewValues = parsedNewValues.map(ff => ff.trim());
                                      } catch (e) {
                                        /* */
                                      }

                                      try {
                                        parsedNewValues = parsedNewValues.filter(ff => ff.length > 0);
                                      } catch (e) {
                                        /* */
                                      }


                                      try {
                                        parsedNewValues = parsedNewValues.filter((value, index, self) => self.indexOf(value) === index);
                                      } catch (e) {
                                        /* */
                                      }

                                      if (window.extendedLog) {
                                        parsedNewValues.map(ff => {
                                          console.log(`TARGET SCAN VALUE: ["${ff}"]`, isValidFQDN(ff) ? `VALID FQDN` : `INVALID FQDN`, isValidIP(ff) ? `[VALID IP]` : `[INVALID IP]`)
                                        });
                                      }



                                      setErrorText("")
                                      setSearchvalue(parsedNewValues);

                                    }}
                                  />
                                </div>
                              </Root>
                              <Root
                                onClick={(event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  try {
                                    setMousePosition(event.clientX, event.clientY);

                                    let el = document.querySelector(".scan-input-input");

                                    const nativeEvent = new MouseEvent('mousedown', {
                                      bubbles: true,
                                      cancelable: true,
                                      view: window,
                                      buttons: 1,
                                    });

                                    el.dispatchEvent(nativeEvent);
                                  } catch (e) {/**/ }
                                }}

                                style={{
                                  zIndex: 1,
                                }}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    marginTop: 20,
                                    maxWidth: "calc(100% - 127px)",
                                    marginLeft: 55,
                                    padding: 8,
                                    height: 197,
                                    maxHeight: 197,
                                    background: inputBgColor(isDarkMode),
                                    borderRadius: 8,
                                  }}{...getRootProps()}>

                                  <div className={"closeStyledTagTxt"}
                                    title="Clear credentials"
                                    style={{
                                      top:-17,
                                      right:22,
                                      color: isDarkMode ? "white" : "black",
                                      opacity:credValue?.length > 0 ? 0.7 : 0,
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      rest.getClearProps().onClick()
                                    }}
                                  >CLEAR</div>

                                  <div
                                    style={{
                                      position: "absolute",
                                      width: "calc(100% - 46px)",
                                      background: inputBgColor(isDarkMode),
                                      marginTop: 0,
                                      marginLeft: 0,
                                      padding: 10,
                                      zIndex: 1111,
                                      borderRadius: 8,
                                      fontSize: 15,
                                      color: isDarkMode ? "rgba(255,255,255,0.84)" : "rgba(0,0,0,0.64)",
                                      pointerEvents: "none",
                                    }}>
                                    {protocolList.filter(p => p.type != "aws-ssm").length > 0 ? `Select credentials ( ${credValue.map(a => a.selected).length}/ ${protocolList.filter(p => p.type != "aws-ssm").length} ) ` : ""}
                                    {APPFACTOR_JSON_EDITOR_THEME_ICONS.chevron}
                                  </div>
                                  <InputWrapper
                                    style={{
                                      width: "calc(100% - 0px)",
                                      opacity: (protocolList.filter(p => p.type != "aws-ssm").length > 0) ? 1 : 0,
                                      padding: 4,
                                      border: "unset",
                                      borderRadius: 8,
                                      paddingTop: 41,
                                      paddingLeft: 8,
                                      paddingRight: 0,
                                      height: "64px",
                                      maxHeight: "64px",
                                      background: "transparent",
                                      overflow: "scroll",
                                      scrollbarWidth: "thin",
                                      scrollbarColor: "var(--scan-main-input-chip-bg-color) transparent",
                                      flex: 1,
                                    }} ref={setAnchorEl} className={focused ? "afocused noScroll iwCredentials" : "noScroll xxx"}>
                                    {credValue
                                      .filter(f => { return f.type !== "aws-ssm" })
                                      .map((option, index) => {
                                        return (
                                          <StyledTag
                                            onClick={(e) => {
                                            }}
                                            label={<>{option.label}
                                            <div style={{
                                              opacity: 0.7,
                                              position: "absolute",
                                              right: 4,
                                              top: 4,
                                            }}>
                                              <CloseRoundedIcon />
                                            </div>
                                            </>} {...getTagProps({ index })} key={"st" + index} />)
                                      }
                                      )}
                                    <input
                                      onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        setMousePosition(event.clientX, event.clientY);
                                      }}
                                      className="scan-input-input"
                                      {...getInputProps()}
                                      style={{
                                        zIndex: 1,
                                        marginTop: -3,
                                        fontSize: 16,
                                        // background: isDarkMode?"rgba(0,0,0,0)":"rgba(252,252,252,1)",
                                        color: isDarkMode ? "rgba(255,255,255,0.84)" : "rgba(0,0,0,0.64)",
                                        maxHeight: 38,
                                        marginRight: 20,
                                      }}
                                      autoComplete={'one-time-code'}
                                    />
                                    {/* {credValue.length > 0 ? <div className={"closeStyledTag"} style={{
                                    position: "absolute",
                                    right: 0,
                                    zIndex: 100,
                                    maxHeight: 18,
                                    maxWidth: 18,
                                    borderRadius: "99em",
                                    paddingTop: 6,
                                    paddingLeft: 6,
                                    border:"1px solid red",
                                    top: 32,
                                    transform: "scale(1.1)"
                                  }}
                                    onClick={(e) => {
                                      document.querySelector("#scan-input").focus()
                                      rest.dirty = true;
                                      credValue.splice(0, credValue.length);
                                      document.querySelector(".simpleAdd").focus()
                                    }}
                                  >{closeIcon}</div> : <></>} */}
                                  </InputWrapper>


                                </div>
                              </Root>

                              <div className={"noScroll simpleAdd"}
                                style={{
                                  position: "absolute",
                                  marginTop: -88,
                                  marginLeft: 73,
                                  maxWidth: "calc(100% - 154px)",
                                  minWidth: "calc(100% - 154px)",
                                  width: "calc(100% - 154px)",
                                  minHeight: 64,
                                }}
                              >
                                <div className="cButton below add"
                                  style={{
                                    marginLeft: 0,
                                    padding: 0,
                                    paddingLeft:0,
                                    paddingRight:0,
                                    marginRight:14,
                                    zIndex: 1000,
                                    minWidth: 132,
                                    textAlign:"center",
                                    fontSize: 12,
                                  }}
                                  onClick={() => {
                                    try {
                                      delete sessionStorage.lastProtocolType
                                    } catch (e) {
                                      /* */
                                    }

                                    if (gdata.connected) {
                                      setOpen(true)
                                    }

                                  }}>
                                    <div 
                                    style={{
                                      marginTop:-2,
                                      marginLeft:-8,
                                      fontSize: 20  
                                    }}
                                    >+</div>Add Credential
                                </div>

                                {
                                  protocolList
                                    .filter(p => p.type != "aws-ssm")
                                    .filter(p => !credValue.map(cv => cv.label).includes(p.label))
                                    .map((p, i) => {

                                      return (<div key={i}
                                        className="cButton below cred"
                                        style={{
                                          marginLeft: i == 0 ? 0 : 0,
                                        }}

                                        onClick={() => {
                                          rest.dirty = true

                                          credValue.push(p)
                                          document.querySelector("#scan-input").focus()
                                        }}>
                                        {p.label.length > 15 ?
                                          <Tooltip enterDelay={1500} title={p.label}><div className="noScroll atext">{p.label}</div></Tooltip>
                                          :
                                          <div className="noScroll atext">{p.label}</div>
                                        }

                                        <div style={{
                                          position: "absolute",
                                          right: 4,
                                          marginTop: 0,
                                        }}>{plusIcon}</div>
                                      </div>)
                                    })
                                }
                              </div>
                            </div>
                            <div style={{
                              textAlign: "left",
                              position: "relative",
                              width: "calc(100% - 57px)",
                              height: "42px",
                              paddingBottom: 0,
                              marginLeft: "42px",
                              marginTop: 29
                            }}>
                              <HorizontalMenu
                                textColor={(searchvalue.length > 0 && credValue.length > 0) ?
                                  "rgba(255,255,255,0.86)" : "rgba(255,255,255,0.86)"}
                                //  disabled={scanning || !gdata.connected}
                                isDark={true}
                                maxWidth={"242px"}
                                noScale={true}
                                bgColor={(searchvalue.length > 0 && credValue.length > 0) ?
                                tagColor : "rgba(52,52,52,0.5)"}
                                onChangeValue={(e, val) => {
                                }}
                                addLabel={false}
                                alignleft={true}
                                menuItems={[
                                  <div
                                    className={"startScanButton"}
                                    style={{ display: "inline-block", maxWidth: "110px" }}
                                    onClick={() => {
                                      if (scanning || !gdata.connected) {
                                        return;
                                      }
                                      setDoneProgress({})
                                      startScan()
                                    }}>
                                    <span style={{ paddingLeft: scanning ?10:30 }}>{scanning ?"SCANNING ...":"Scan"}</span>
                                    <span style={{
                                      fontWeight: 600,
                                      paddingLeft: 30,
                                    }}> </span>
                                   
                                  </div>

                                ]}
                                menuValues={["scan"]}
                              />
                              {viewOption == "scan" &&
                              <div style={{
                              display: gdata.connected && firstScan ? "block" : "none",
                              filter: gdata.connected ? "unset" : "grayscale(100%)",
                              position: "absolute",
                              // right: localStorage.vCenterScan?160:120,
                              marginLeft: -20,
                              marginTop: 0,
                              right:31,
                              width: "230px",
                              height:42,
                              overflowY: "visible",
                              overflowX: "hidden",
                            }}>
                              <HorizontalMenu
                                noUnderline={true}
                                noScale={true}
                                addLabel={false}
                                alignleft={true}
                                value={gdata.connected ? activeScanType : "a"}
                                setValue={setActiveScanType}
                                disabled={!gdata.connected}
                                onChangeValue={(e, val) => {
                                  if (val && val != activeScanType) {
                                    setActiveScanType(val);
                                  }
                                }}
                                menuItems={[
                                  <div
                                    style={{ display: "inline-block" }}
                                    onClick={() => {
                                      if (scanning || !gdata.connected) {
                                        return;
                                      }

                                      setOpenScanAll(true);
                                    }}
                                  >Rescan all hosts</div>]}
                                menuValues={["rescan"]}
                                menuCounts={
                                  [storeSystems.length || -1]}

                              ></HorizontalMenu>
                            </div>
                            }





                            {viewOption == "scan" &&
                              <div style={{
                              display: gdata.connected && firstScan ? "block" : "none",
                              filter: gdata.connected ? "unset" : "grayscale(100%)",
                              position: "absolute",
                              // right: localStorage.vCenterScan?160:120,
                              marginLeft: -20,
                              marginTop: 0,
                              right:260,
                              width: localStorage.vCenterScan ? "284px" : "140px",
                              height:42,
                              overflowY: "visible",
                              overflowX: "hidden",
                            }}>
                              <HorizontalMenu
                              noUnderline={true}
                              noScale={true}
                                addLabel={false}
                                alignleft={true}
                                value={gdata.connected ? activeScanType : "a"}
                                setValue={setActiveScanType}
                                disabled={!gdata.connected}
                                onChangeValue={(e, val) => {
                                  if (val && val != activeScanType) {
                                    setActiveScanType(val);
                                  }
                                }}
                                menuItems={[
                                  ...(localStorage.vCenterScan ? [
                                    <div
                                      style={{ display: "inline-block" }}
                                      onClick={() => {
                                        setSearchvalue(JSON.parse(localStorage.vCenterScan))
                                        setAddedFromVcenter(true)
                                      }}
                                    >&nbsp;&nbsp;vCenter&nbsp;&nbsp;</div>
                                  ] : []),
                                  <div
                                    style={{ display: "inline-block" }}
                                    onClick={() => {
                                      if (scanning || !gdata.connected) {
                                        return;
                                      }
                                      setAwsScan(true)
                                    }}
                                  >&nbsp;&nbsp;AWS-SSM</div>
                                ]}
                                menuValues={[
                                  ...(localStorage.vCenterScan ? ["vcenterscan"] : []),
                                  "awsscan"]}
                                menuCounts={
                                  [
                                    ...(localStorage.vCenterScan ? [(JSON.parse(localStorage.vCenterScan || "[]") || []).length] : []),

                                    protocolList.filter(p => p.type == "aws-ssm").length > 0 ? protocolList.filter(p => p.type == "aws-ssm").length : -1]}

                              ></HorizontalMenu>
                            </div>
                            }

                            </div>
                            { ( scanHistory?.scanAutocomplete?.length > 0) ?
                              <div style={{
                                paddingTop: 0,
                                position: "absolute",
                                fontSize: 24,
                                marginRight: 0,
                                color: "rgba(128,128,128,0.9)",
                                right: 56,
                                top: -35,
                                // width: 0 alone still lets the label text overflow and peek
                                // out from behind the progress panel while scanning
                                display: !firstScan ? "none" : "block",
                                width: 280,
                                height: 40
                              }}>
                                <div
                                  data-scan-history-toggle="true"
                                  title={`
Scan History :
- press [ctrl]+[shift]+[^] to select history item.
- press [ctrl]+[shift]+[Enter] to start scan.
                                        `}
                                  onClick={() => {
                                    let sh = document.querySelector("#scanHist")
                                    sh.style.display = sh.style.display == "none" ? "block" : "none";
                                  }} style={{
                                    position:"relative",
                                    background: isDarkMode ? "rgba(17,14,15,1)" : "rgba(99,99,99,0.142)",
                                    color: isDarkMode ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)",
                                    padding:12,
                                    paddingTop:12,
                                    paddingLeft:20,
                                    paddingBottom:13,
                                    maxWidth:285,
                                    fontSize: 13,
                                    maxHeight:14,
                                    height: 14,
                                    borderRadius: 8,
                                  }}>Scan History
                                  <div 
                                  style={{
                                    position: "absolute",

                                    right: 16,
                                    marginTop: -14,
                                  }}
                                  >
                                  {APPFACTOR_JSON_EDITOR_THEME_ICONS.chevron}
                                  </div>
                                  </div>

                                {/* Scan history, in the credentials menu's clothes: the
                                    same card, the same head with its mark, the same rows
                                    with a gutter for theirs and a delete that appears on
                                    hover. The keys stay where they were - `sHis1`..`sHis9`
                                    is what ctrl+N clicks (see the shortcut above). */}
                                <div
                                  id={"scanHist"}
                                  className="actionMenuItems scan-history-menu orion-tokens"
                                  style={{ display: "none" }}
                                >
                                  <ul className={"noScroll"}>
                                    <div className="row-menu__head">
                                      <span className="row-menu__badge">
                                        <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                                          <path
                                            d="M13 3a9 9 0 1 0 8.94 10h-2.02A7 7 0 1 1 13 5a6.96 6.96 0 0 1 4.9 2.1L15 10h7V3l-2.6 2.6A8.97 8.97 0 0 0 13 3Zm-1 5v5l4.25 2.52.75-1.23-3.5-2.08V8H12Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      <span className="row-menu__who">
                                        <span className="row-menu__name">Scan history</span>
                                      </span>
                                      {scanHistory.scanAutocomplete.length > 0 && (
                                        <span
                                          className="scan-history-menu__clear"
                                          title="Clear all scan history"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            var yes = confirm(`Are you sure you want to delete all scan history?`);
                                            if (yes) {
                                              setScanHistory(p => {
                                                let newHistory = { ...p, scanAutocomplete: [] };
                                                localStorage.scanHistory = JSON.stringify(newHistory);
                                                return newHistory;
                                              })
                                            }
                                          }}
                                        >
                                          Clear
                                        </span>
                                      )}
                                    </div>

                                    {scanHistory.scanAutocomplete.length === 0 && (
                                      <li className="scan-history-menu__empty">Nothing scanned yet.</li>
                                    )}

                                    {scanHistory.scanAutocomplete.map((m, i) => (
                                      <li
                                        key={`scanHistoryBox_${i}`}
                                        /* the shortcut's own handle */
                                        className={`sHis${i + 1}`}
                                        onClick={() => {
                                          rest.dirty = true
                                          while (credValue.length > 0) {
                                            credValue.pop()
                                          }
                                          m.protocols.forEach(pr => {
                                            credValue.push(pr)
                                          })

                                          setSearchvalue(m.search)

                                          document.querySelector("#scan-input").focus()

                                          let dt = document.querySelector(".discoveryTable");

                                          const nativeEvent = new MouseEvent('mousedown', {
                                            bubbles: true,
                                            cancelable: true,
                                            view: window,
                                            buttons: 1
                                          });

                                          dt.dispatchEvent(nativeEvent);
                                        }}
                                      >
                                        <div className="row-menu__item">
                                          <span className="row-menu__icon">
                                            <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
                                              <path
                                                d="M13 3a9 9 0 1 0 8.94 10h-2.02A7 7 0 1 1 13 5a6.96 6.96 0 0 1 4.9 2.1L15 10h7V3l-2.6 2.6A8.97 8.97 0 0 0 13 3Zm-1 5v5l4.25 2.52.75-1.23-3.5-2.08V8H12Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </span>
                                          <span className="credential-menu__label" title={m.search.join(" ")}>
                                            {m.search.join(" ")}
                                          </span>
                                        </div>

                                        {/* the first nine answer to ctrl and their own number */}
                                        {i <= 8 && <span className="scan-history-menu__key">{i + 1}</span>}

                                        <span
                                          className="credential-menu__delete"
                                          title={`Remove "${m.search.join(" ")}"`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setScanHistory(p => {
                                              let newHistory = {
                                                ...p,
                                                scanAutocomplete: p.scanAutocomplete.filter(s => s.search != m.search)
                                              }
                                              localStorage.scanHistory = JSON.stringify(newHistory);
                                              return newHistory
                                            })
                                          }}
                                        >
                                          <svg width={13} height={13} viewBox="0 0 24 24" fill="none">
                                            <path
                                              d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>

                              </div>
                              :
                              <></>
                            }

                            {/* end scan page */}
                          </> : offlineGraceOver ?
                        <NotConnectedOrchestrator gdata={gdata} setAnchorElScan={setAnchorElScan} downloadRef={downloadRef} isDarkMode={isDarkMode} />
                        : null
                      }
                    </div>
                  </div>
                  {/* The panel's contents are hidden while the store is locked, but the
                      artwork stays: it is what gives the page behind the password
                      prompt its colour, and hiding it left a flat black screen. What
                      made an empty panel read as a second dialog was the frame -
                      .main-bg-overlay's border and frosted fill - so that is dropped
                      while locked and only the soft glow remains. */}
                  {/* stretched: the artwork's own 1305x742 box scales uniformly
                      otherwise, so when this column narrows for the progress log
                      the card's painted panel shrank in height too and the form
                      stood outside it */}
                  {scanCardReady &&
                    (isDarkMode
                      ? <MainBg2 isDarkMode={isDarkMode} stretch frameless={secretStoreLocked}></MainBg2>
                      : <MainBg isDarkMode={isDarkMode} stretch frameless={secretStoreLocked}></MainBg>)}
                </div>
              }
{
  viewOption == "ascan" &&
  <div
  style={{
    position: "relative",
    marginTop: 170,
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    maxWidth: 1103,//1086
    minWidth: 0,
    minHeight: 620,//611
    maxHeight: 620,
  }}
  >

     <MainBg isDarkMode={isDarkMode}></MainBg>
  </div>
}
              {
                viewOption == "index" &&
                <div style={{
                  position: "relative",
                  marginTop: 170,
                  /* Centred by its own margins rather than by a formula off the
                     container's width: while a scan runs this column narrows to
                     make room for the progress log, and that formula went
                     negative - which slid the card under the rail and cut the
                     IP field off. It gives way instead. */
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "100%",
                  maxWidth: 1103,//1086
                  minWidth: 0,
                  minHeight: 620,//611
                  maxHeight: 620,
                  paddingTop: "1px",
                }}>
                  {/* The progress panel that used to sit over this column is
                      gone: the scan's hosts, its tiles and its counters are all
                      in the progress log now, and a second copy of them here
                      only covered the index. The minimized tab stays - it is
                      how the log is brought back. */}
                  {minimizedProgressTab}

                  <div style={{
                    color: isDarkMode ? "#FFFFFF" : "#000000",
                    zIndex: 2,
                    position: "relative",
                    marginTop: 50,
                    marginLeft: 70,
                    // border: "1px solid rgba(255,255,255,0.23)",
                    width: "calc(100% - 140px)",
                    height: "calc(100% - 0px)",
                    // overflowY: "scroll",
                  }}>
                    <div style={{ fontSize: 16, width: "100%", height: "100%" }}>Index custom data sources</div>
                    {showScanView ?
                      <>
                        <div style={{ fontSize: 14, marginTop: 4, width: "100%", height: "100%", opacity: 0.5 }}>Select data sources to be indexed {dataSourcesList.length > 0 ? `( ${dataSourcesList.length} items )` : ""}</div>
                        <div 
                         className={`mainContainer-scan ${!firstScan && !progressMinimized ? "scanning" : ""}`}
                        style={{
                          marginTop: 38,
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          overflowY: "scroll",
                          scrollbarWidth: "thin",
                          scrollbarColor: "var(--scan-main-input-chip-bg-color) rgba(0,0,0,0)",
                          maxHeight: 338,
                          height: 338,
                          paddingBottom: 30,
                          gap: 20
                        }}>
                          {
                            dataSourcesList.map((m, i) => {
                              return (
                               <RepoItem 
                               setActiveRepoName={setActiveRepoName}
                               repoName={`repoItem_${i}`}
                               gData={gdata}
                               dataSourcesList={dataSourcesList}
                               setOpenEditIndexPage={setOpenEditIndexPage}
                               hide={scanning}
                               setDoneProgress={setDoneProgress} startScan={startScan} showDeleteButton={true} refreshDataSources={refreshDataSources} key={`repoItem_${i}`} m={m} i={i} isDarkMode={isDarkMode} />
                              )
                            })
                          }

                        <EditIndexPage 
                              key={`editIndexPage_${activeRepoName}`}
                              repoName={activeRepoName}
                              title={`Edit data source "${ activeRepoName }"` }
                              refreshDataSources={refreshDataSources}
                              isDarkMode={isDarkMode} 
                              gdata={gdata}
                              dataSourcesList={dataSourcesList}
                              openAddIndexPage={openEditIndexPage}
                              setOpenAddIndexPage={(a)=>{
                                if( a==false){
                                  setActiveRepoName("");
                                }
                                setOpenEditIndexPage(a);
                              }}
                              editDataSource={dataSourcesList.find(m => m.name == activeRepoName)}
                          />
                          

                        </div>
                        <Button
                          style={{
                            opacity: scanning ? 0.3 : 1,
                            filter: scanning ? "grayscale(100%)" : "none",
                            pointerEvents: scanning ? "none" : "auto",
                            color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
                            fontSize: 14,
                            marginTop: 24,
                            // marginLeft:-86,
                            maxWidth: 128,
                            minWidth: 128,
                            maxHeight: 32,
                            minHeight: 22,
                            padding: "4px !important",
                            borderRadius: 4,
                            border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
                          }}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();

                            setDoneProgress({})
                            startScan(dataSourcesList);
                          }}>INDEX ALL</Button>
                        <Button
                          style={{
                            opacity: !firstScan ? 0 : 1,
                            pointerEvents: !firstScan ? "none" : "auto",
                            color: isDarkMode ? "rgba(255,255,255,1)" : "rgba(0,0,0,0.5)",
                            fontSize: 20,
                            float: "right",
                            marginTop: 24,
                            maxWidth: 42,
                            minWidth: 42,
                            maxHeight: 32,
                            minHeight: 22,
                            padding: 0,
                            borderRadius: 4,
                            border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
                          }}
                          onClick={(event) => {
                            setOpenAddIndexPage(true);
                          }}>+</Button>
                      </>
                      : offlineGraceOver ?
                      <div style={{
                        position: "relative",
                        marginTop: 100,
                        marginLeft: 2,
                      }}>
                        <NotConnectedOrchestrator gdata={gdata} setAnchorElScan={setAnchorElScan} downloadRef={downloadRef} isDarkMode={isDarkMode} />
                      </div>
                      : null
                    }
                  </div>
                  {isDarkMode? <MainBg2 isDarkMode={isDarkMode}></MainBg2>:
                  <MainBg isDarkMode={isDarkMode}></MainBg>}




                </div>
              }

              <div style={{
                position: "relative",
                maxWidth: 970,
                minWidth: 970,
                minHeight: 14,
                maxHeight: 82,
                marginLeft: "calc(((100%/2) - (1160px/2)))",
                opacity: errorText == "" ? 0 : 1,
                borderRadius: 4,
                fontSize: 12,
                // position: "absolute",
                padding: 8,
                paddingLeft: 38,
                paddingRight: 32,
                backgroundColor: "rgba(65,18,48, 1)",
                color: "rgba(255, 176, 198, 1)"
              }}>
                <svg
                  width={18}
                  height={18}
                  style={{
                    marginLeft: -28,
                    marginTop: -2,
                    position: "absolute"
                  }}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1532_8129)">
                    <path
                      d="M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z"
                      fill="#D73964"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1532_8129">
                      <rect width={24} height={24} fill="white" />
                    </clipPath>
                  </defs>
                </svg>




                {errorText}
                <svg
                  onClick={() => setErrorText("")}
                  style={{
                    background: "rgba(0,0,0,0.01)",
                    position: "absolute",
                    float: "right",
                    top: 8,
                    right: 8,
                  }}
                  width={14}
                  height={14}
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                    fill="#FFB0C6"
                  />
                </svg>

              </div>

              <div style={{
                position: "relative",
                maxWidth: 760,
                minWidth: 760,
                display: warning.length > 0 ? "block" : "none",
                padding: 8,
                marginTop: 12,
                borderRadius: 4,
                paddingLeft: 38,
                paddingRight: 32,
                float: "left",
                marginLeft: "calc(((100%/2) - (840px/2)))",
                marginRight: 20,
                background: "rgba(73, 45, 38, 1)",
                color: "rgba(255, 212, 169, 1)",
                textAlign: "left"
              }}>
                <svg
                  style={{
                    marginLeft: -28,
                    marginTop: -2,
                    position: "absolute"
                  }}
                  width={18}
                  height={18}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
                    fill="#F19436"
                  />
                </svg>
                {warning}
                <svg
                  onClick={() => setWarning("")}
                  style={{
                    background: "rgba(0,0,0,0.01)",
                    position: "absolute",
                    float: "right",
                    right: 8,
                    top: 8,
                  }}
                  width={14}
                  height={14}
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                    fill="#FFD4A9"
                  />
                </svg>

              </div>

              {(scanHistory.success.length > 0 || scanHistory.fail.length > 0) && gdata.connected ?
                <>
                  <div style={{
                    marginTop: 42,
                    paddingTop: 22,
                    fontSize: 20,
                    width: "calc(100% - 24px)",
                    // borderTop: "1px solid rgb(255,255,255,0.2)"
                  }}>Local History</div>

                  <div style={{
                    marginTop: 42,
                    float: "left",
                    display: "flex",
                    gap: 24,
                    width: "calc(100% - 2px)"
                  }}>
                    {(scanHistory.success.length > 0) && gdata.connected ?
                      <div style={{ flex: 1 }}>
                        <div style={{
                          position: "relative",
                          paddingLeft: 10,
                          paddingTop: 14,
                          width: "calc(100% - 10px)",
                          borderRadius: "8px 8px 0 0",
                          border: "1px solid rgba(255,255,255,0.23)",
                          background: "linear-gradient(180deg, rgba(191, 196, 192, 0.2) 1.83%, rgba(134, 134, 134, 0.2) 100%)",
                          height: 36,
                          fontSize: 16
                        }}>
                          {/* <span>&#10003;</span> */}
                          <div style={{
                            marginLeft: 10,
                            fontSize: 16
                          }}
                            className={"successScans"}>{scanHistory.success.length}</div>
                          <div style={{ display: "inline-block" }}>Successes</div>
                          <div style={{
                            position: "absolute",
                            top: 12,
                            right: 12
                          }} onClick={() => {
                            if (confirm('Click ok if you want to clear success history?')) {
                              setScanHistory(p => {
                                let newP = {
                                  success: [],
                                  fail: p.fail,
                                  scanAutocomplete: p.scanAutocomplete
                                }

                                localStorage.scanHistory = JSON.stringify(newP)

                                return newP;
                              });
                            }
                          }}><CloseRoundedIcon style={{ opacity: 0.5 }} /></div>

                        </div>
                        <ScanResult
                          setValue={setSearchvalue}
                          systemMap={systemMap}

                          dataTimes={
                            scanHistory.timeSuccess
                          }

                          data={
                            scanHistory.success
                            // progressTree
                            //   .filter(a => a.message_type == "success")
                            //   .map(a => a.host)
                            //   .filter((a, i, ar) => ar.indexOf(a) === i)
                          }></ScanResult>
                      </div>
                      : <></>}
                    {(scanHistory.fail.length > 0) && gdata.connected ?
                      <div style={{ flex: 1 }}>
                        <div style={{
                          position: "relative",
                          paddingLeft: 10,
                          paddingTop: 14,
                          width: "calc(100% - 10px)",
                          border: "1px solid rgba(255,255,255,0.23)",
                          background: "linear-gradient(180deg, rgba(191, 196, 192, 0.2) 1.83%, rgba(134, 134, 134, 0.2) 100%)",
                          borderRadius: "8px 8px 0 0",
                          height: 36,
                          fontSize: 16

                        }}>
                          {/* <span>&#10003;</span> */}
                          <div style={{
                            marginLeft: 10,
                            fontSize: 16
                          }}
                            className={"failScans"}>
                            {scanHistory.fail.length}
                          </div>
                          <div style={{ display: "inline-block" }}>Fail</div>

                          <div style={{
                            position: "absolute",
                            top: 12,
                            right: 12
                          }} onClick={() => {
                            if (confirm('Click ok if you want to clear failure history?')) {
                              setScanHistory(p => {
                                let newP = {
                                  success: p.success,
                                  fail: [],
                                  scanAutocomplete: p.scanAutocomplete
                                }

                                localStorage.scanHistory = JSON.stringify(newP)

                                return newP;
                              });
                            }
                          }}><CloseRoundedIcon style={{ opacity: 0.5 }} /></div>

                        </div>
                        <ScanResult
                          systemMap={systemMap}
                          setValue={setSearchvalue}
                          dataTimes={
                            scanHistory.timeFail
                          }

                          data={
                            scanHistory.fail
                            // progressTree
                            //   .filter(a => a.message_type == "failure")
                            //   .map(a => a.host)
                            //   .filter((a, i, ar) => ar.indexOf(a) === i)
                          }></ScanResult>
                      </div>
                      : <></>}
                  </div>
                </> :
                <></>}

            </div>
            <div
              className={`main-scan-progress-right-panel ${isDarkMode ? "" : "no"}niceBorder ${Object.keys(doneProgress).length > 0 ? "hidden" : ""}`}
              style={{
                position: "relative",
                float: "right",
                /* 526 is what it wants, not what it must have: it keeps that
                   width while the window has room and gives way below it,
                   rather than running off the right edge */
                flex: firstScan ? "0 0 0px" : "0 0 auto",
                width: 526,
                maxWidth: "40%",
                minWidth: 380,
                marginLeft: 0,
                borderRadius: 8,
                display: (firstScan || progressMinimized) ? "none" : "block",
                // border: `${isDarkMode? 1: 0 }px solid rgba(255,255,255,0.2)`,
                // background: isDarkMode ? "rgba(2,2,2,1)" : "rgba(243,243,243,1)",
                background:"rgb(32,32,32)",
                height: "calc(100vh - 20px)",
                zIndex: 999,
              }}>

              {/* the scan's tiles, at the top of the log: what was running is
                  read above what it wrote. The block spans the panel and takes
                  a third of its height; the chart fills whatever it is given. */}
              {showProgressChart &&
                <div
                  className="scan-progress-tiles"
                  style={{
                    position: "absolute",
                    top: 56,
                    left: 14,
                    right: 14,
                    height: "30%",
                    zIndex: 98,
                  }}
                >
                  {/* interactive: the tiles sit clear of the log now, so a tile
                      can say whose it is on hover and take the log to that host
                      when it is clicked */}
                  <ScanProgressTiles source={progressChartSource} interactive />
                </div>
              }

              <div className={"progressLog scan"} style={{
                padding: 0,
                position: "absolute",
                top: 77,
                paddingTop: 11,
                border: "0px solid transparent",
                zIndex: 99,
                width: "calc(100% - 22px)",
              }}>
                <div style={{
                  position: "absolute",
                  marginLeft: 2,
                  paddingLeft: 63
                }}>
                  <div
                    title={scanning ? "Minimize — the scan keeps running" : "Close"}
                    style={{
                    // background: "rgba(255,255,255, 0.1)",
                    width: 22,
                    zIndex: 1111,
                    position: "absolute",
                    left: 6,
                    top: -2,
                    height: 20,
                    borderRadius: 4,
                    paddingTop: 1,
                    paddingBottom: 3,
                    cursor: "pointer",
                  }}
                    onClick={() => {
                      if (scanning) {
                        setProgressMinimized(true);
                      } else {
                        setFirstScan(true);
                      }
                    }}
                  >
                    {scanning ? minimizeIcon : closeIcon}
                  </div>


                  <div className={"hoverToggle"}
                    style={{
                      position: "absolute",
                      left: 114,
                      top: 0,
                      zIndex: 99
                    }}
                    onClick={() => {
                      setLogViewTree(p => !p);
                    }}
                  >{menuTogleIcon}</div>
                  {statsCounts.total > 0 && <div className={"tolalScans"}>{statsCounts.total} <div>TOTAL</div></div>}
                  {statsCounts.success > 0 && <div className={"successScans"}>{statsCounts.success} <div>SUCCESS</div></div>}
                  {statsCounts.failure > 0 && <div className={"failScans"}>{statsCounts.failure} <div>FAIL</div></div>}



                </div>
                <div style={{
                  float: "right",
                  position: "relative",
                  paddingTop: 3,
                  paddingBottom: 3,
                  marginRight: 10,
                  marginTop: -2,
                  paddingRight: 25,
                  paddingLeft: 10,
                  borderRadius: 8,
                  minWidth: 52,
                  minHeight: 16,
                }}>{typeof scanStartTime !== 'undefined' && scanStartTime != 0 ? scanDurationTime : ""}
                  {scanning ? <>
                    <div style={{
                      transform: "scale(0.8)",
                      float: "right",
                      right: 14,
                      top: 0,
                      width: 10,
                      height: 10,
                      position: "absolute"

                    }}>{loadingIcon}</div>

                  </> : <>
                    <div style={{
                      float: "right",
                      right: 5,
                      top: 5,
                      width: 10,
                      height: 10,
                      position: "absolute"

                    }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="14px"
                        height="14px"
                        style={{
                          marginLeft: -1.5,
                          marginTop: -1
                        }}
                      >
                        <circle cx="12" cy="12" r="11.42" fill="rgba(176,176,176,1)" fillOpacity="1" stroke="transparent" strokeWidth="0.42" />
                        <path
                          fill="rgba(61, 98, 37, 1)"
                          d="M11,16.4l-4.7-4.7l1.4-1.4l3.3,3.3l8.4-8.4C17.5,3.3,14.9,2,12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10 c0-1.9-0.5-3.6-1.4-5.1L11,16.4z"
                        />
                      </svg>
                    </div>
                  </>}
                </div>

                <div style={{
                  float: "right",
                  paddingRight: 10,
                  paddingTop: 2,
                }}>Progress Log </div>

              </div>
              <div className={"noScroll"}
                ref={refScroller}
                style={{
                  position: "relative",
                  minHeight: "calc(100% - 4px)",
                  padding: 6,
                  paddingLeft: 6,
                  /* The tiles are drawn over the top of this panel, so the log
                     starts under them rather than behind them: they run from
                     56px down over 30% of the panel's own calc(100vh - 20px),
                     which puts their foot at 30vh + 50, and the log clears that
                     by 14. The canvas log begins at its own top edge, where the
                     table used to carry a toolbar and a 20px offset of its own. */
                  marginTop: showProgressChart ? "calc(30vh + 64px)" : 6,
                  borderRadius: 7,
                  background: "transparent",
                  top: 0,
                  right: 0,
                  minWidth: "200px",
                  width: "calc(100%)",
                  /* ends with the panel rather than running past its foot: the
                     log scrolls inside itself */
                  overflow: logViewTree ? "scroll" : "hidden",
                  height: showProgressChart ? "calc(70vh - 84px)" : "calc(100vh - 40px)",
                }}>

                <div
                  style={{
                    minWidth: "340px",
                    maxWidth: "calc(100%)",
                    marginTop: 4,
                    height: "calc(100% - 10px)",
                    maxHeight: "calc(100% - 10px)",
                    padding: 0
                  }}
                >
                  {logViewTree ?
                    <div className="progress-table" style={{
                      position: "relative",
                      top: 20,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      width: "calc(100% - 20px)",
                      height: "calc(100% - 20px)",
                      color: isDarkMode ? "white" : "black",
                    }}>
                      <JsonEditor
                        data={progressTree}
                        theme={jsonEditorTheme}
                        icons={APPFACTOR_JSON_EDITOR_THEME_ICONS}
                        level={1}
                        maxWidth={630}
                        collapse={2}
                        restrictEdit={true}
                        restrictDelete={true}
                        restrictAdd={true}
                        rootName={" "}
                      />
                    </div>

                    : <>
                      {/* the log itself: one canvas in place of the table, its
                          toolbar, its head cells and a detail panel per row */}
                      <ScanProgressLog source={progressChartSource} />
                    </>
                  }</div>
              </div>
            </div>

          </div>
        </div>
        <div>
          <AddCredential existingProtocols={protocolList.map(p => p.label)} enableImport={enableImport} secretsListType={secretsListType} secretsList={secretsList} setOpen={setOpen} open={open}></AddCredential>
        </div>
      </div>
    </>
  );
}

export default Scan